export const advisorEn = {
  advisor: {
    title: "Legacy — Sentinel Advisor Weekly Action Center",
    subtitle: "Weekly recommendations and action checklist",
    legacyProductBadge: "Legacy",
    cockpitTitle: "Gaucho",
    cockpitSubtitle: "Supervised farm operations cockpit",
    cockpitSafetyBadge: "Supervised · no execution",
    legacySectionNote:
      "Older weekly checklist kept for reference. Gaucho's supervised cockpit above is the primary view.",
    refresh: "Refresh recommendations",
    loading: "Analyzing your parcel data...",
    selectParcel: "Select a parcel",
    noParcels: "You don't have any parcels registered yet.",
    askInstead: "Ask about a parcel",
    placeholder: "Type a parcel name or question (e.g. 'Parcela Vill, irrigation')",
    send: "Send",
    priority: "Priority",
    cost: "Cost impact",
    risk: "Risk",
    confidence: "Confidence",
    evidence: "Evidence used",
    missingData: "Missing data",
    nextStep: "Next step",
    explain: "Explain",
    openIrrigation: "Open Irrigation Optimizer",
    openCropHealth: "Open Crop Health",
    openNotebook: "Open Field Notebook",
    openNitrogen: "Open Nitrogen Optimizer",
    openReports: "Open Reports Center",
    openPestDisease: "Open Pest & Disease",
    generateReport: "Generate report",
    safetyDecisionSupport: "Decision-support only — validate in field before acting.",
    error: "Could not load recommendations. Please try again.",
    high: "High",
    medium: "Medium",
    low: "Low",
    demoBadge: "Demo — sample data",
    noParcelTitle: "No parcel selected",
    noParcelMessage: "Select a parcel to generate parcel-level recommendations.",
    selectParcelBtn: "Select parcel",
    openParcels: "Open parcels",
    portfolioBadge: "Portfolio-wide recommendation",
    appliesTo: "Applies to",
    appliesToAllParcels: "all parcels with sufficient data",
    appliesToNParcels: "{{count}} parcels",
    openVegetationIndices: "Open Vegetation Indices",
    openSatelliteMonitoring: "Open Satellite Monitoring",
    unavailableTitle: "Sentinel Advisor is temporarily unavailable",
    unavailableMessage: "We couldn't load recommendations right now. You can still review parcels or open Reports Center.",
    selectParcelLabel: "Select a parcel",
    analyzeParcel: "Analyze parcel",
    noParcelsTitle: "No parcels yet",
    noParcelsMessage: "Create your first parcel to use Sentinel Advisor.",
    addParcel: "Add parcel",
    parcelNotFound: "Selected parcel not found or not accessible.",
    evidenceAvailable: "Evidence available",
    costSavingGuidance: "Cost-saving guidance",
    doNotConclude: "What not to conclude",
    openVegetationIndicesShort: "Vegetation Indices",
    createFieldObservation: "Create field observation",
    generateMonitoringReport: "Generate monitoring report",
    requiredToImprove: "Required to improve this recommendation",
    requiredToImproveHint: "To provide a complete recommendation, Sentinel Advisor needs updated satellite imagery, current FAO-56 ET0/ETc and a 7-day forecast. Open the modules below to update or validate the missing data.",
    openNdviZones: "Open NDVI Zones",
    openSplitView: "Open Split View",
    openIrrigationReports: "Open Irrigation Reports",
    openDrought: "Open Drought & Water Stress",
    openDiseaseRiskMap: "Open Disease Risk Map",
    openPK: "Open P&K Optimizer",
    openFoliar: "Open Foliar Analysis",
    openParcelPassport: "Open Digital Parcel Record",
    openTraceability: "Open Traceability",
    openAlerts: "Open Alerts",
    openCalendar: "Open Calendar",
    weeklyActionCenter: "Weekly Action Center",
    statusPending: "Pending review",
    statusBlocked: "Blocked — missing data",
    statusAccepted: "Accepted",
    statusCompleted: "Completed",
    statusDismissed: "Dismissed",
    statusExpired: "Expired",
    openAgain: "Open again",
    allActionsCompleted: "All recommended actions for this recommendation have been completed.",
    requiredToComplete: "Required to complete recommendation",
    actionRefresh: "Open module to refresh data",
    actionRecalculate: "Open module to recalculate",
    actionCreateTask: "Create scouting task",
    actionCreateObservation: "Create field observation",
    actionGenerateReport: "Generate report",
    actionReanalyze: "Re-analyze parcel",
    actionOpenModule: "Open module",
    accept: "Accept",
    dismiss: "Dismiss",
    markDone: "Mark done",
    markReviewed: "Mark as reviewed",
    undo: "Undo",
    manualChip: "Manual",
    activityLog: "Activity log",
    actionUnavailableHint: "Automation not available yet — open the module to perform this manually.",
    actionChecklist: "Action checklist",
    secondaryActions: "More modules",
    actionOpenNotebookCreateObservation: "Open Field Notebook to create observation",
    actionOpenReportsGenerate: "Open Reports Center to generate report",
    reviewedHint: "These are user-confirmed manual completions.",
    evtCreated: "Recommendation created",
    evtOpenedModule: "User opened module",
    evtMarkedDone: "Required action marked done",
    evtAccepted: "Recommendation accepted",
    evtDismissed: "Recommendation dismissed",
    evtAwaitingData: "Awaiting updated data",
    evtReanalyzed: "Recommendation re-analyzed",
    evtMissingNdvi: "Satellite (NDVI) data missing or stale",
    evtMissingEt0: "FAO-56 ET0/ETc data missing or stale",
    evtMissingWeather: "Weather forecast missing or stale",
    actionDoneToast: "Action marked done",
    actionFailedToast: "Could not update recommendation",
    lastAnalysis: "Last analysis",
    justNow: "just now",
    minAgo: "{{n}} min ago",
    refreshShort: "Refresh",
    chkReviewSatellite: "Review satellite data",
    chkReviewIrrigation: "Review irrigation data",
    chkAddObservation: "Add field observation",
    chkGenerateReport: "Generate report manually",
    chkReviewModule: "Review recommended module",
    chkRefreshEt0: "Refresh ET0 / FAO-56 calculation",
    chkRefreshWeather: "Refresh 7-day weather forecast",
    chkRefreshNdvi: "Review or update satellite vegetation data",
    chkReviewIrrigationRec: "Review irrigation recommendation",
    chkGenerateEvidenceReport: "Generate decision report",
    chkGeneratePartialEvidenceReport: "Generate partial evidence report",
    et0ReviewedButMissing: "ET0 refresh was reviewed, but no fresh ET0 data is available yet.",
    forecastReviewedButMissing: "Forecast refresh was reviewed, but no fresh 7-day forecast is available yet.",
    chkReviewVegetationIndices: "Review vegetation indices",
    ctaRefreshEt0AndForecast: "Refresh ET0 & forecast",
    ctaRefreshEt0: "Refresh ET0",
    ctaRefreshWeather: "Refresh forecast",
    ctaRefreshNdvi: "Refresh satellite imagery",
    ctaReviewVegetationIndices: "Review vegetation indices",
    manualRefreshNote: "This data must be refreshed from the linked module.",
    refreshWeatherNow: "Refresh forecast now",
    refreshWeatherInProgress: "Refreshing forecast…",
    refreshWeatherDone: "7-day forecast refreshed",
    refreshWeatherFailed: "Could not refresh the forecast. Try again in a moment.",
    refreshWeatherMissingCoords: "Parcel has no coordinates — open Parcels to set its location.",
    opensIrrigationOptimizer: "Opens Irrigation Optimizer.",
    opensSatelliteMonitoring: "Opens Satellite Monitoring.",
    opensReportsCenter: "Opens Reports Center.",
    opensFieldNotebook: "Opens Field Notebook.",
    opensVegetationIndices: "Opens Vegetation Indices.",
    needsRefreshChip: "Needs refresh",
    moduleRequiredChip: "Module required",
    expandAdvisor: "Expand window",
    collapse: "Shrink window",
    expandWindow: "Expand window",
    shrinkWindow: "Shrink window",
    actionsPending: "{{n}} actions pending",
    secActionRecommendation: "Recommendation",
    secActionEvidence: "Evidence",
    secActionMissing: "Missing or stale data",
    secActionRecommendedAction: "Recommended action",
    secActionSupporting: "Supporting modules",
    secActionChecklist: "Action checklist",
    secActionWorkflow: "Workflow",
    secActionActivityLog: "Activity log",
    workflowDescription: "Manage the status of this recommendation. These controls do not execute field operations automatically.",
    acceptTooltip: "Confirm that this recommendation is relevant and should remain active.",
    dismissTooltip: "Discard this recommendation. It will not be prioritized unless new data changes the analysis.",
    reanalyzeTooltip: "Run the analysis again using the latest available parcel data.",
    workflowFooterNote: "These controls manage the recommendation status. Operational actions are completed from the linked modules or by marking checklist items as reviewed.",
    templates: {
      ndvi: {
        inspect_low_vigor: "Inspect the low-vigor zone {{zone_id}} (minimum NDVI {{min_ndvi}}). Walk the area and confirm symptoms in field before drawing conclusions.",
        trend_review: "Review the NDVI / NDRE trend for the last {{window_days}} days and compare against the previous cycle before scheduling any field operation.",
      },
      fao56: {
        irrigation_quantified: "Reference crop water demand (ETc) is {{etc_mm_per_day}} mm/day over the next {{horizon_days}} days. This is crop evapotranspiration evidence for review only and is not an irrigation application amount.",
        irrigation_validate_first: "Update the live forecast and record the latest irrigation event. ETc describes crop water demand only and does not define an irrigation application amount.",
        collect_irrigation_log: "Log recent irrigation events in the Field Notebook so the water-balance evidence stays complete for review. No irrigation application amount is produced.",
        risk_outlook_water_stress: "Monitor potential water stress if rainfall remains limited. Current evidence is incomplete because applied irrigation records and live forecast are missing.",
      },
      sar: {
        descriptive_only_note: "Sentinel-1 SAR soil-moisture signal is descriptive only. It cannot be used by itself to trigger irrigation — validate in field.",
      },
      pest: {
        scouting_priority: "{{alert_count}} pest/disease alert(s) are present for this parcel. Prioritize field scouting and validate symptoms before deciding any treatment.",
        not_evaluated_window: "Pest & disease risk has not been evaluated for this report window. Field scouting is required before drawing conclusions.",
        routine_scouting_no_active_alerts: "No active pest or disease alerts are present in the available evaluated data. Continue routine field scouting.",
      },
      soil: {
        collect_lab_data: "No persisted soil or lab analysis is available. Upload a recent soil/lab analysis so the agent can compute a nutrient recommendation.",
      },
      weather: {
        forecast_incomplete: "The 7-day weather forecast is incomplete. Refresh the forecast so the agent can evaluate atmospheric demand.",
        frost_prep: "Minimum temperature of {{min_temp_c}} °C is expected on {{event_date}}. Prepare frost-protection measures and validate exposure in field.",
      },
    },
    autonomy: {
      direct_action: "Direct action",
      field_validation_required: "Field validation required",
      data_required: "Data required",
      blocked: "Blocked — no signal",
    },
    actionPlan: {
      sectionTitle: "Autonomous Agronomic Action Plan",
      betaBadge: "Beta — deterministic, evidence-gated",
      action: "Action",
      priority: "Priority",
      autonomy: "Autonomy",
      module: "Module",
      evidenceUsed: "Evidence reference",
      evidenceMissing: "Evidence missing",
      doNotConclude: "Do not conclude",
      none: "No autonomous actions could be emitted: evidence is insufficient.",
    },
    dataSummaryHeading: "Data summary recommendations",
    dataSummarySubtitle: "Supporting context — the Autonomous Agronomic Action Plan above is the farmer-facing action layer.",
    readiness: {
      heading: "Data readiness",
      et0Stale: "ET0/ETc not current — open Irrigation Optimizer to refresh the FAO-56 calculation.",
      et0Missing: "ET0/ETc not available for this parcel — open Irrigation Optimizer to run the FAO-56 calculation.",
      forecastStale: "7-day forecast not current for this parcel — open Weather & Conditions to refresh the forecast.",
      forecastMissing: "7-day forecast not available for this parcel — open Weather & Conditions to refresh the forecast.",
      et0Current: "Latest ET0: FAO-56 daily, updated {{date}}.",
      forecastCurrent: "Latest forecast: weather forecast, updated {{date}}.",
      openIrrigationOptimizer: "Open Irrigation Optimizer",
      openWeatherConditions: "Open Weather & Conditions",
    },
    legacyBadge: "Legacy recommendation",
    legacyHint: "Surfaced by the previous Advisor pipeline. Gaucho above is the authoritative readout.",
    statusReviewRequired: "Review required",
    statusSupersededByFarmOps: "Superseded by Gaucho",
    etcInvalidInline: "ETc invalid — refresh FAO-56 calculation",
    et0InvalidInline: "ET0 invalid — refresh FAO-56 calculation",
    lifecycle: {
      sectionTitle: "Crop Lifecycle & Post-Harvest Planning",
      sectionSubtitle: "Structured questions to plan post-harvest soil restoration safely. No species or seed mix is recommended in this beta.",
      betaBadge: "Beta — deterministic, evidence-gated",
      priority: "Priority",
      evidenceUsed: "Evidence used",
      evidenceMissing: "Evidence missing",
      doNotConclude: "What not to conclude",
      persistenceNote: "Planning input — persistence coming in the next slice.",
      priorityValues: { low: "Low", medium: "Medium", high: "High" },
      urgency: {
        immediate_review: "Immediate review",
        today: "Today",
        next_24h: "Next 24h",
        next_7d: "Next 7 days",
        routine: "Routine",
      },
      suggestedTasks: "Suggested tasks",
      rankedPriorities: "Ranked priorities",
      tasksHumanReviewBadge: "Requires human review",
      tasksNotExecutedAutomatically: "Not executed automatically.",
      dailyBriefTitle: "Today's brief",
      dailyBriefTopRisks: "Top risks",
      dailyBriefTopPriorities: "Today's priorities",
      dailyBriefSuggestedTasks: "Suggested tasks",
      memoryTitle: "Parcel memory",
      memoryEmpty: "No historical parcel evidence available yet.",
      memoryError: "Unable to load historical evidence right now.",
      memoryStale: "(stale)",
      memoryHistoricalContextBadge: "Historical context",
      memoryRecentConfirmations: "Recent confirmations",
      memoryRecentReports: "Recent reports",
      memoryRecentFieldActivities: "Recent field activities",
      memoryRecentIrrigation: "Recent irrigation records",
      memoryRecentScouting: "Recent scouting records",
      memoryRecentSoilFoliar: "Soil / foliar evidence",
      memoryRecentSeasons: "Crop lifecycle history",
      memoryRecentRisks: "Historical risk records",
      memoryStatus: {
        loaded: "Loaded",
        empty: "Empty",
        error: "Error",
        not_loaded: "Not loaded",
      },
      autonomy: {
        data_required: "Data required",
        field_validation_required: "Field validation required",
        blocked: "Blocked — no signal",
      },
      state: {
        active_crop: "Active crop",
        near_harvest: "Near harvest",
        harvested_confirmed: "Harvested (confirmed)",
        post_harvest_window: "Post-harvest window",
        unknown: "Unknown",
      },
      templates: {
        "lifecycle.confirm_harvest_status": {
          title: "Crop lifecycle check",
          message: "We could not confirm the lifecycle stage from existing evidence. Please confirm the harvest status to enable post-harvest planning.",
        },
        "lifecycle.declare_next_crop": {
          title: "Next crop required",
          message: "Declare the next planned crop so post-harvest planning can be evaluated.",
        },
        "lifecycle.declare_post_harvest_objective": {
          title: "Post-harvest objective",
          message: "Declare your main post-harvest objective so the agent can prepare planning inputs.",
        },
        "lifecycle.planning_ready_pending_field_validation": {
          title: "Post-harvest planning ready",
          message: "Post-harvest planning inputs are available. Field validation is required before recommending any cover crop strategy.",
        },
      },
      questions: {
        confirm_harvest_status: "Has the primary crop been harvested?",
        declare_next_crop: "What is the next planned crop?",
        declare_post_harvest_objective: "What is your main post-harvest objective?",
      },
      options: {
        harvested_confirmed: "Harvested",
        near_harvest: "Near harvest",
        active_crop: "Still active",
        unknown: "Not sure",
        nitrogen_fixation: "Nitrogen fixation",
        erosion_control: "Erosion control",
        soil_structure: "Soil structure",
        weed_suppression: "Weed suppression",
        biodiversity: "Biodiversity",
        organic_matter: "Organic matter",
        moisture_conservation: "Moisture conservation",
      },
      missing: {
        harvest_status: "Harvest status",
        next_crop: "Next planned crop",
        post_harvest_objective: "Post-harvest objective",
        forecast_7d: "7-day forecast",
        soil_analysis: "Soil / lab analysis",
      },
      doNotConcludeItems: {
        cover_crop_species: "Cover crop species",
        cover_crop_mix: "Cover crop mix",
        soil_restoration_guarantee: "Soil restoration guarantee",
        fertilizer_prescription: "Fertilizer prescription",
        pesticide_prescription: "Pesticide prescription",
      },
    },
    farmOps: {
      emptyEvidence: {
        title: "Gaucho is ready, but has no confirmed evidence yet",
        subtitle:
          "The parcel is selected and the cockpit is loaded. Nothing below is generated or assumed \u2014 Gaucho only shows what it can actually read today.",
        whyLimited:
          "No deterministic operational brief could be produced for this parcel yet, so supervised recommendations stay limited until the required data is available.",
        errorPrefix: "Data load issue",
      },
      globalSupervisionNote:
        "Supervised assistant \u2014 every item requires human review; nothing is executed automatically.",
      sections: {
        briefPriorities: "Full brief and priorities",
        needsFromYou: "What Gaucho needs from you",
        preparationReadiness: "Preparation and readiness",
        actionPlanDetail: "Action plan and observations",
        recommendationsModuleStatus: "Recommendations and module status",
        evidenceDetail: "Detailed evidence context",
        supervisedPackages: "Supervised action packages",
        historyRotation: "Parcel history and rotation",
        boundaries: "Scope and boundaries",
        evidenceContext: "Evidence context",
        modules: "Connected dashboard modules",
        updateGuide: "How to update your data",
      },
      today: {
        title: "Today",
        globalStatus: {
          operational: "Operational",
          attention: "Needs attention",
          limited: "Limited by evidence",
          blocked: "Blocked",
        },
        evidenceConflict: "Conflicting evidence requires review",
        irrigationNotNeededYet: "Irrigation not needed yet",
        additionalEvidenceNote:
          "These are additional missing items. The irrigation decision stays blocked by the canonical blocker above.",
        noPriorities: "No operational priority is pending review today.",
        viewFullBrief: "View full brief and priorities",
      },
      commercialCockpit: {
        title: "Gaucho operations cockpit",
        subtitle:
          "One supervised view of what Gaucho knows about this parcel, which dashboard modules it reads today, what is still missing and which safe review steps it can suggest.",
        badge: "Supervised assistant",
        parcelLabel: "Parcel",
        noParcel: "Select a parcel to load the cockpit.",
        summaryTitle: "Operational summary",
        modulesTitle: "Connected dashboard modules",
        modulesSubtitle:
          "Status is derived from real read paths only. Nothing here is generated or assumed.",
        knowsTitle: "What Gaucho knows now",
        knowsEmpty: "Gaucho has no confirmed evidence for this parcel yet.",
        needsTitle: "What Gaucho needs next",
        needsEmpty: "No required evidence is missing right now.",
        nextStepTitle: "Safe next step",
        nextStepEmpty: "No safe next step is available for this parcel yet.",
        demoTitle: "Commercial demo readiness",
        demoLevels: {
          not_ready: "Not ready — connect more parcel evidence first",
          partial: "Partially ready — some modules still need data",
          demo_ready: "Ready to demo — core modules are reading real evidence",
        },
        cannotTitle: "What Gaucho cannot do",
        cannot: {
          no_execution:
            "Gaucho never carries out field operations on your behalf.",
          no_product_or_rate:
            "Gaucho never names inputs, quantities or per-hectare figures.",
          no_treatment_instruction:
            "Gaucho never issues plant-protection or nutrition instructions.",
          no_machinery_operation:
            "Gaucho never starts, schedules or dispatches machinery or irrigation equipment.",
          no_claim_or_submission:
            "Gaucho never files claims, legal, insurance or administrative submissions.",
          no_auto_analysis_run:
            "Gaucho never runs paid risk analysis or fertility calculations on its own.",
        },
        openModule: "Open module",
        supervisedNote:
          "Every suggestion below is a human-review step. You stay in control of every field decision.",
      },
      moduleStatus: {
        connected: "Connected",
        available: "Available",
        limited: "Limited",
        missing: "Missing data",
        review_only: "Review only",
        not_connected: "Not connected",
        blocked: "Out of scope",
        descriptions: {
          connected: "Gaucho reads real parcel data from this module today.",
          available: "Data exists and the module can be opened, but Gaucho does not summarise it.",
          limited: "Only partial context is reachable; Gaucho links out instead of concluding.",
          missing: "This module is wired to Gaucho but has no data for this parcel yet.",
          review_only: "Sensitive module — Gaucho references it, never concludes from it.",
          not_connected: "No saved parcel-level result exists yet; run the module manually.",
          blocked: "Not part of the agricultural crop experience.",
        },
      },
      sidebarIntegration: {
        title: "Sidebar coverage",
        groups: {
          dashboard: "Dashboard",
          parcel: "Parcel",
          monitor: "Monitor",
          risk: "Risk",
          decide: "Decide",
          report: "Report",
          prove: "Prove",
        },
      },
      connectedModules: {
        title: "Module grid",
        modules: {
          overview: "Overview",
          multi_farm: "Multi-farm overview",
          manage_parcels: "Manage parcels",
          field_notebook: "Field notebook",
          calendar: "Calendar",
          seasons: "Seasons",
          satellite_images: "Satellite images",
          vegetation_indices: "Vegetation indices",
          ndvi_zones: "NDVI zones",
          weather_conditions: "Weather & conditions",
          phenology: "Phenology intelligence",
          foliar_analysis: "Foliar analysis",
          agronomy_tools: "Agronomy tools",
          alerts: "Alerts",
          drought_water_stress: "Drought & water stress",
          pest_disease: "Pest & disease risk",
          frost_protection: "Frost protection",
          fire_detection: "Fire detection",
          agronomic_risk_ml: "Agronomic risk assessment",
          economic_risk: "Economic risk impact",
          irrigation_optimizer: "Irrigation optimizer",
          irrigation_reports: "Irrigation reports",
          nitrogen_optimizer: "Nitrogen optimizer",
          pk_optimizer: "P&K optimizer",
          vra_builder: "Yield-to-VRA builder",
          reports_center: "Reports center",
          compliance_readiness: "Compliance readiness check",
          parcel_passport: "Digital parcel record",
        },
        updateSteps: {
          overview: "Complete the parcel setup.",
          multi_farm: "Confirm your parcels and boundaries.",
          manage_parcels: "Update the boundary and confirm the crop.",
          field_notebook: "Add a field observation.",
          calendar: "Review the calendar manually.",
          seasons: "Create or confirm the active season.",
          satellite_images: "Review the latest imagery.",
          vegetation_indices: "Check the index trend and validate anomalies.",
          ndvi_zones: "Validate low-vigour zones in the field.",
          weather_conditions: "Review the weather context.",
          phenology: "Update the active season to sharpen the stage estimate.",
          foliar_analysis: "Add or update a foliar analysis record.",
          agronomy_tools: "Open the relevant tool manually.",
          alerts: "Review the active alerts.",
          drought_water_stress: "Review the drought and water-stress context.",
          pest_disease: "Validate symptoms with a field observation.",
          frost_protection: "Review the frost risk context.",
          fire_detection: "Review the fire evidence.",
          agronomic_risk_ml: "Run the risk assessment manually to create context.",
          economic_risk: "Open the economic risk view manually.",
          irrigation_optimizer: "Update ET, rainfall and the irrigation log.",
          irrigation_reports: "Generate an irrigation report.",
          nitrogen_optimizer: "Add soil or foliar evidence, then open the optimizer.",
          pk_optimizer: "Add soil or foliar evidence, then open the optimizer.",
          vra_builder: "Review the builder manually.",
          reports_center: "Generate an evidence report.",
          compliance_readiness: "Review the compliance readiness check.",
          parcel_passport: "Prepare the traceability evidence.",
        },
      },
      safeRecommendations: {
        title: "Safe supervised recommendations",
        subtitle:
          "Review steps derived from real module evidence. None of them is an instruction to act in the field.",
        empty: "No supervised recommendation is available for this parcel yet.",
        safetyNote: "Human review required. Gaucho does not carry this out for you.",
        reviewOnlyNote:
          "Sensitive module — Gaucho can only ask you to review it with a qualified agronomist.",
        types: {
          evidence_review: "Review evidence",
          module_review: "Review module",
          missing_data_update: "Update missing data",
          field_validation: "Validate in field",
          report_generation: "Generate report",
          qualified_review_required: "Qualified review required",
          manual_optimizer_review: "Review optimizer manually",
          risk_context_review: "Review risk context",
          traceability_review: "Review traceability",
        },
        typeDescriptions: {
          evidence_review: "Check the saved evidence before making a decision.",
          module_review: "Open the module and review it manually.",
          missing_data_update: "Add the missing information so Gaucho can build stronger context.",
          field_validation: "Confirm what the data suggests with your own field observation.",
          report_generation: "Produce an evidence report before sharing this parcel externally.",
          qualified_review_required: "Ask a qualified agronomist to review before deciding.",
          manual_optimizer_review: "Open the optimizer yourself and review the parcel-specific figures.",
          risk_context_review: "Review the non-binding risk context manually.",
          traceability_review: "Review the traceability record for completeness.",
        },
      },
      updateDataGuide: {
        title: "How to update the information Gaucho needs",
        subtitle:
          "Gaucho only reads what you have saved. Update these areas to unlock stronger evidence-backed review steps.",
        footerNote:
          "Updating data never unlocks execution. Gaucho stays a supervised assistant.",
        items: {
          parcel: {
            label: "Parcel data",
            desc: "Confirm the boundary, crop and area in Manage parcels.",
          },
          season: {
            label: "Season data",
            desc: "Create or confirm the active season with its planting date.",
          },
          satellite: {
            label: "Satellite / vegetation data",
            desc: "Open the imagery and index pages so recent observations are available.",
          },
          weather: {
            label: "Weather, water and irrigation data",
            desc: "Keep ET, rainfall and the irrigation log up to date for the parcel.",
          },
          soil: {
            label: "Soil and foliar data",
            desc: "Add or refresh soil and foliar analysis records.",
          },
          risk: {
            label: "Risk and economic data",
            desc: "Run the agronomic risk assessment manually when you need that context.",
          },
          fertility: {
            label: "Fertility optimizer review",
            desc: "Open the nitrogen and P&K optimizers yourself and review the figures.",
          },
          observations: {
            label: "Field observations and field notebook",
            desc: "Record what you see in the field so Gaucho can align data with reality.",
          },
          reports: {
            label: "Reports and evidence",
            desc: "Generate an evidence report when you need to share the parcel externally.",
          },
          compliance: {
            label: "Compliance and digital parcel record",
            desc: "Review the readiness check and the digital parcel record.",
          },
          actionPlan: {
            label: "Action plan and supervised review",
            desc: "Accept, progress and review the action plan so the supervised audit stays complete.",
          },
        },
      },
      sectionTitle: "Gaucho — Farm Operations Assistant",
      sectionSubtitle: "Supervised evidence-based farm operations assistant focused on resource efficiency.",
      productMessage: "Gaucho helps make each parcel more efficient by turning satellite, weather, soil, scouting and field evidence into daily priorities, safe tasks and operational memory.",
      betaBadge: "Beta — deterministic, evidence-gated",
      controlledPreviewBadge: "Gaucho · Controlled preview",
      parcelStatus: "Parcel status",
      priorities: "Priority instructions",
      quantifiedIrrigation: "Reference crop water demand",
      referenceCropDemand: "Reference crop water demand",
      referenceCropDemandValue: "Crop evapotranspiration {{etc}} mm/day over {{days}} days. Modelled crop water use — not an amount to apply.",
      applicationTargetUnavailable: "No irrigation application target is available. Review with your agronomist before irrigating.",
      blockedDecisions: "Decisions blocked",
      evidenceUsed: "Evidence used",
      evidenceMissing: "Evidence missing",
      requiredQuestions: "Required questions",
      structuredAnswers: "Structured answers only",
      questionsAnswered: "All required questions answered for this window.",
      qIrrigationLabel: "Did this parcel receive irrigation during the current window?",
      qHarvestLabel: "Has the primary crop been harvested?",
      btnNoIrrigation: "No irrigation applied",
      btnIrrigationApplied: "Irrigation applied",
      btnNotSure: "Not sure",
      btnStillActive: "Still active",
      btnNearHarvest: "Near harvest",
      btnHarvested: "Harvested",
      saveSuccessTitle: "Confirmation saved",
      saveFailedTitle: "Could not save this confirmation",
      saveFailedDescription: "Please try again or contact support.",
      unsupportedPersistenceDescription: "This answer cannot be saved safely with the current field notebook setup. The decision remains blocked.",
      statusSaved: "Saved",
      statusBlocked: "Evidence still required",
      statusRequiresSeason: "Requires season setup",
      msgNoIrrigationNotPersisted: "No-irrigation confirmation is not yet persisted in this version. The irrigation decision remains blocked until this confirmation type is supported.",
      msgIrrigationUncertain: "Irrigation status remains uncertain. The irrigation decision remains blocked.",
      msgLifecycleUncertain: "Lifecycle status is uncertain. Lifecycle-dependent decisions remain blocked until confirmed.",
      msgRequiresSeason: "No active crop season found. Open Seasons to create or confirm the crop season first.",
      msgError: "Could not save this confirmation. Please try again or contact support.",
      msgNotAuthenticated: "Sign-in required to save this confirmation.",
      fieldDate: "Date",
      fieldAmount: "Amount (optional)",
      fieldAmountPlaceholder: "e.g. 12",
      fieldUnit: "Unit",
      fieldScope: "Scope",
      scopeWholeParcel: "Whole parcel",
      fieldNotes: "Notes (optional)",
      fieldHarvestDate: "Harvest date",
      fieldYieldKgHa: "Yield (kg/ha, optional)",
      fieldNextCrop: "Next crop planned (optional)",
      fieldPostHarvestObjective: "Post-harvest objective",
      objNitrogenFixation: "Nitrogen fixation",
      objErosionControl: "Erosion control",
      objSoilStructure: "Soil structure",
      objWeedSuppression: "Weed suppression",
      objBiodiversity: "Biodiversity",
      objOrganicMatter: "Organic matter",
      objMoistureConservation: "Moisture conservation",
      save: "Save",
      nextSteps: "Recommended next steps",
      doNotConclude: "What not to conclude",
      days: "days",
      zone: "Zone",
      priorityValues: { low: "Low", medium: "Medium", high: "High", critical: "Critical" },
      showMore: "+ {{count}} more",
      showLess: "Show less",
      urgency: {
        immediate_review: "Immediate review",
        today: "Today",
        next_24h: "Next 24h",
        next_7d: "Next 7 days",
        routine: "Routine",
      },
      lifecycle: {
        active_crop: "Active crop",
        near_harvest: "Near harvest",
        harvested_confirmed: "Harvested",
        post_harvest_window: "Post-harvest window",
        unknown: "Lifecycle not confirmed",
      },
      decisions: {
        irrigation_amount_by_zone: "Irrigation amount by zone",
        irrigation_timing: "Irrigation timing",
        irrigation_need: "Irrigation need",
        fertilization_recommendation_n: "Nitrogen recommendation",
        fertilization_recommendation_pk: "P & K recommendation",
        vra_export_readiness: "VRA export readiness",
        report_generation_requirement: "Report generation",
        compliance_evidence_check: "Compliance evidence check",
        lifecycle_planning_questions: "Lifecycle planning",
        frost_protection_prep: "Frost protection",
        drought_outlook: "Drought outlook",
        scouting_priority_by_zone: "Scouting priority by zone",
      },
      reasons: {
        quantified_irrigation_gate_not_satisfied: "Quantified irrigation gate not satisfied.",
        sar_contradiction_with_field_evidence: "SAR signal contradicts field evidence.",
        forecast_7d_missing: "7-day forecast is missing.",
        no_persisted_soil_or_foliar_evidence: "No persisted soil or foliar evidence.",
        low_vigor_zone_requires_field_validation_before_irrigation:
          "Low-vigor zone requires field validation before irrigation.",
      },
      evidence: {
        parcel_id: "Parcel identity",
        crop_type: "Crop type",
        area_ha: "Area (ha)",
        ndvi_trend: "NDVI trend",
        ndre_trend: "NDRE trend",
        vigor_zones: "Vigor zones",
        zone_area: "Zone area",
        vegetation_anomaly: "Vegetation anomaly",
        satellite_recency: "Satellite recency",
        phenological_stage: "Phenological stage",
        foliar_analysis: "Foliar analysis",
        weather_current: "Current weather",
        forecast_7d: "7-day forecast",
        et0: "ET0",
        etc: "ETc",
        kc_dual: "FAO-56 dual Kc",
        irrigation_log: "Applied irrigation log",
        no_irrigation_confirmation: "No-irrigation confirmation",
        sar_soil_moisture: "SAR soil moisture",
        active_alerts: "Active alerts",
        drought_risk: "Drought risk",
        pest_disease_risk: "Pest / disease risk",
        frost_risk: "Frost risk",
        fire_risk: "Fire risk",
        agronomic_risk_ml: "Agronomic ML risk",
        economic_risk: "Economic risk",
        nitrogen_recommendation: "Nitrogen recommendation",
        pk_recommendation: "P & K recommendation",
        vra_zones: "VRA zones",
        irrigation_report: "Irrigation report",
        soil_lab_analysis: "Soil / lab analysis",
        evidence_report: "Evidence report",
        compliance_pac_readiness: "Compliance / PAC readiness",
        parcel_passport: "Digital parcel record",
        audit_trail: "Audit trail",
        harvest_status: "Harvest status",
        next_crop: "Next planned crop",
        post_harvest_objective: "Post-harvest objective",
        farm_context: "Farm context",
        season_state: "Season state",
        planting_event: "Planting event",
        harvest_event: "Harvest event",
        planned_operations: "Planned operations",
        field_events: "Field events",
        harvested_confirmed: "Harvest confirmed",
        near_harvest_confirmed: "Near harvest confirmed",
        crop_active_confirmed: "Crop active confirmed",
        next_crop_declared: "Next crop declared",
        post_harvest_objective_declared: "Post-harvest objective declared",
        current_crop_known: "Current crop known",
        previous_crop_known: "Previous crop known",
        soil_analysis_present: "Soil analysis available",
        foliar_analysis_present: "Foliar analysis available",
        field_validation_or_scouting_present: "Field validation or scouting available",
        planting_window_known: "Planting window known",
        water_availability_known: "Water availability known",
        location_context_known: "Location context known",
      },
      evidenceSummary: {
        recent_phenology_evidence_near_harvest_or_post_harvest_stage:
          "Recent phenology observations indicate a near-harvest or post-harvest stage.",
        recent_phenology_evidence_available: "Recent phenology observations available.",
        recent_foliar_evidence_indicates_poor_or_fair_overall_health:
          "Recent foliar analysis indicates poor or fair overall health.",
        recent_foliar_evidence_available: "Recent foliar analysis available.",
        recent_soil_analysis_indicates_ph_or_organic_matter_concern:
          "Recent soil analysis indicates a pH or organic-matter concern.",
        recent_soil_analysis_available: "Recent soil analysis available.",
        recent_vegetation_indices_available: "Recent vegetation-index observations available.",
        recent_drought_water_stress_evidence_available:
          "Recent drought / water-stress evidence available.",
        soil_analysis_present: "Soil analysis available.",
        foliar_analysis_present: "Foliar analysis available.",
        field_validation_or_scouting_present: "Field validation or scouting available.",
        pest_disease_scouting_completeness_sufficient_for_review:
          "Pest & disease scouting completeness: sufficient for agronomic review.",
        pest_disease_scouting_completeness_partial:
          "Pest & disease scouting completeness: partial.",
        pest_disease_scouting_completeness_incomplete:
          "Pest & disease scouting completeness: incomplete.",
        pest_disease_scouting_completeness_no_recent_scouting:
          "Pest & disease scouting completeness: no recent scouting.",
        pest_disease_scouting_completeness_not_applicable:
          "Pest & disease scouting completeness: not applicable.",
      },
      evidenceGroups: {
        identity: "Identity",
        satellite: "Satellite & vegetation",
        water: "Water & irrigation",
        lab: "Lab evidence",
        planning: "Crop planning",
        risk: "Risk",
        other: "Other",
      },
      safetyCategories: {
        field_operations: "Field operations",
        inputs_prescriptions: "Inputs and prescriptions",
        diagnosis: "Diagnosis and causality",
        evidence_limits: "Evidence limits",
        legal_insurance: "Legal, insurance and compliance",
      },
      safetyCategoryDefault: {
        field_operations:
          "Does not execute irrigation, fertigation, spraying, fertilization or machinery operations.",
        inputs_prescriptions:
          "Does not recommend products, doses, blends, active ingredients or application timing.",
        diagnosis:
          "Does not confirm pest, disease, nutrient deficiency, toxicity, water stress or yield loss without qualified validation.",
        evidence_limits:
          "Does not replace field validation, lab interpretation or agronomist review.",
        legal_insurance:
          "Does not conclude insurance validity, compliance status, legal liability or emergency instructions.",
      },
      showSafetyDetails: "Show technical safety details",
      hideSafetyDetails: "Hide technical safety details",
      questions: {
        confirm_harvest_status: "Has the primary crop been harvested?",
        declare_next_crop: "What is the next planned crop?",
        declare_post_harvest_objective: "What is your main post-harvest objective?",
        confirm_no_irrigation: "Confirm whether the parcel received no irrigation in the window.",
        confirm_field_scouting_done: "Confirm whether field scouting has been completed.",
      },
      instructions: {
        refresh_forecast_before_irrigation_amount_and_timing:
          "Refresh the 7-day forecast before computing irrigation amount or timing.",
        upload_or_import_soil_lab_analysis:
          "Upload or import a recent soil / lab analysis.",
        prioritize_field_scouting_for_active_alerts:
          "Prioritize field scouting for the active pest / disease alerts.",
        low_vigor_zone_requires_field_scouting_before_irrigation:
          "Low-vigor zone requires field scouting before irrigation.",
        review_current_water_state_for_zone:
          "Review the current water-state evidence for this zone. Vigor does not determine an irrigation application amount.",
        generate_evidence_report_if_decisions_are_shared:
          "Generate an evidence report if decisions are being shared with third parties.",
        review_foliar_analysis_with_agronomist:
          "Review the foliar analysis with a qualified agronomist.",
        review_soil_analysis_with_agronomist:
          "Review the soil analysis with a qualified agronomist.",
        compare_soil_with_foliar_phenology_and_rotation:
          "Compare soil analysis with foliar, phenology and rotation context.",
        validate_crop_stage_against_lifecycle:
          "Validate the crop stage against the parcel lifecycle before scheduling operations.",
        review_crop_stage_context_near_harvest:
          "Review crop-stage context — parcel is near harvest.",
        validate_satellite_hotspot_with_official_sources_and_field_check:
          "Validate the satellite hotspot with official emergency sources and a field check.",
        validate_vegetation_anomaly_in_field:
          "Validate the vegetation anomaly in field before drawing conclusions.",
        validate_water_stress_in_field_and_review_fao56_and_irrigation_log:
          "Validate water stress in field and review the FAO-56 calculation and irrigation log.",
        review_foliar_analysis_and_nutrient_balance_with_qualified_agronomist:
          "Review the foliar analysis and nutrient balance with a qualified agronomist.",
        review_soil_analysis_and_compare_with_foliar_phenology_and_rotation:
          "Review the soil analysis and compare with foliar, phenology and rotation context.",
        refresh_foliar_analysis_via_existing_foliar_analysis_module:
          "Refresh the foliar analysis from the Foliar Analysis module.",
        complete_pest_disease_scouting_details_and_validate_symptoms_in_field:
          "Complete pest & disease scouting details and validate symptoms in field.",
        pest_disease_scouting_missing_observation_date:
          "Missing observation date.",
        pest_disease_scouting_missing_observation_type:
          "Missing pest / disease observation type.",
        pest_disease_scouting_missing_severity_class:
          "Missing severity class.",
        pest_disease_scouting_missing_symptom_description:
          "Missing symptom description.",
        pest_disease_scouting_missing_affected_organ:
          "Missing affected plant organ.",
        pest_disease_scouting_missing_incidence_estimate:
          "Missing incidence estimate (approximate percentage of plants affected).",
        pest_disease_scouting_missing_spatial_distribution:
          "Missing spatial distribution (localized, scattered or widespread).",
        pest_disease_scouting_missing_photo_evidence:
          "Missing photo evidence.",
        pest_disease_scouting_missing_phenological_stage:
          "Missing phenological stage (BBCH context).",
        pest_disease_scouting_missing_recent_weather_context:
          "Missing recent weather context.",
        pest_disease_scouting_missing_treatment_history:
          "Missing recent treatment history.",
        pest_disease_scouting_missing_agronomist_ipm_review:
          "Missing agronomist / IPM advisor review.",
      },
      doNotConcludeItems: {
        herbicide_prescription: "Herbicide prescription",
        fungicide_prescription: "Fungicide prescription",
        pesticide_prescription: "Pesticide prescription",
        treatment_product: "Treatment product",
        treatment_dose: "Treatment dose",
        treatment_timing: "Treatment timing",
        guaranteed_diagnosis: "Guaranteed diagnosis",
        cover_crop_species: "Cover crop species",
        cover_crop_mix: "Cover crop mix",
        do_not_conclude_active_fire_from_gaucho: "Does not confirm an active fire.",
        do_not_replace_emergency_services_112: "Does not replace 112 or Protección Civil.",
        do_not_issue_evacuation_instructions: "Does not issue evacuation instructions.",
        do_not_claim_frost_damage: "Does not confirm frost damage.",
        do_not_activate_machinery_or_protection_systems_automatically:
          "Does not activate machinery, heaters, wind machines, irrigation or protection systems automatically.",
        do_not_activate_machinery_heaters_wind_machines_or_irrigation_as_frost_protection_automatically:
          "Does not activate machinery, heaters, wind machines or irrigation as frost protection automatically.",
        do_not_treat_forecast_as_certainty: "Forecast is not certainty.",
        do_not_confirm_diagnosis_from_gaucho: "Does not confirm a pest or disease diagnosis.",
        do_not_recommend_treatment_product_dose_or_application:
          "Does not recommend any product, active ingredient, dose or application.",
        do_not_instruct_spraying_application_treatment_or_execution:
          "Does not instruct spraying, application, treatment or execution.",
        do_not_recommend_pesticide_fungicide_herbicide_biological_control_active_ingredient_or_dose:
          "Does not recommend any pesticide, fungicide, herbicide, biological control, active ingredient or dose.",
        do_not_schedule_or_execute_irrigation_from_this_item:
          "Does not schedule or execute irrigation from this item.",
        do_not_schedule_or_execute_irrigation_from_this_task:
          "Does not schedule or execute irrigation from this task.",
        do_not_relax_fao56_gates: "FAO-56 gates are never relaxed.",
        do_not_quantify_irrigation_from_log_evidence_alone:
          "Does not quantify irrigation from the log alone.",
        do_not_create_irrigation_execution_pump_valve_machinery_or_fertigation_action_from_log_alone:
          "Does not execute irrigation, pump, valve, machinery or fertigation actions from the log alone.",
        do_not_infer_applied_irrigation_from_fao56_demand_ndvi_sar_weather_or_water_stress_alone:
          "Does not infer applied irrigation from FAO-56 demand, NDVI, SAR, weather or water-stress signals alone.",
        do_not_infer_cause_from_ndvi_alone: "Does not infer cause from NDVI alone.",
        do_not_infer_compliance_insurance_or_liability:
          "Does not infer compliance, insurance or liability status.",
        do_not_replace_field_validation: "Does not replace field validation.",
        do_not_replace_qualified_agronomic_judgment:
          "Does not replace qualified agronomic judgment.",
        do_not_recommend_fertilizer_product_or_dose:
          "Does not recommend any fertilizer product or dose.",
        do_not_recommend_sowing_or_planting_execution:
          "Does not recommend sowing or planting execution.",
        do_not_recommend_cover_crop_species_or_mix:
          "Does not recommend specific cover-crop species or mix.",
        do_not_execute_actions_automatically: "Does not execute actions automatically.",
        do_not_conclude_reports_imply_compliance:
          "Historical reports do not imply compliance.",
        do_not_conclude_reports_imply_insurance_validity:
          "Historical reports do not imply insurance validity.",
        do_not_conclude_historical_is_current_diagnosis:
          "Historical evidence does not confirm the current diagnosis.",
        do_not_conclude_historical_replaces_field_validation:
          "Historical evidence does not replace field validation.",
        do_not_conclude_historical_frost_fire_prove_current_emergency:
          "Historical frost/fire records do not prove a current emergency.",
        do_not_conclude_historical_irrigation_proves_current_water_status:
          "Historical irrigation does not prove current water status.",
        do_not_conclude_historical_ndvi_infers_current_cause:
          "Historical NDVI does not infer current cause.",
        do_not_conclude_historical_scouting_confirms_current_pest_disease:
          "Historical scouting does not confirm current pest or disease.",
        do_not_conclude_historical_soil_foliar_implies_product_or_dose:
          "Historical soil/foliar evidence does not imply any product or dose.",
        do_not_conclude_stale_confirmations_override_current_evidence:
          "Stale confirmations do not override current evidence.",
        // Soil analysis safety notes
        soil_do_not_recommend_fertilizer_product_or_dose_alone:
          "Soil evidence alone does not recommend fertilizer product or dose.",
        soil_do_not_recommend_amendment_or_blend_alone:
          "Soil evidence alone does not recommend amendment or blend.",
        soil_do_not_execute_fertilization:
          "Soil evidence does not execute fertilization.",
        soil_do_not_execute_fertigation:
          "Soil evidence does not execute fertigation.",
        soil_do_not_infer_nutrient_deficiency_alone:
          "Soil evidence alone does not confirm nutrient deficiency.",
        soil_do_not_infer_toxicity_alone:
          "Soil evidence alone does not confirm toxicity.",
        soil_do_not_infer_irrigation_need_alone:
          "Soil evidence alone does not infer irrigation need.",
        soil_do_not_relax_fao56_gates:
          "Soil evidence does not relax FAO-56 gates.",
        soil_do_not_override_nitrogen_or_pk_optimizer:
          "Soil evidence does not override the Nitrogen or P&K optimizer.",
        soil_do_not_infer_yield_loss_insurance_compliance_or_liability:
          "Soil evidence does not infer yield loss, insurance, compliance or liability.",
        soil_do_not_replace_agronomist_interpretation:
          "Soil evidence does not replace qualified agronomist interpretation.",
        // Foliar safety notes
        foliar_do_not_recommend_fertilizer_product_or_dose_alone:
          "Foliar evidence alone does not recommend fertilizer product or dose.",
        foliar_do_not_recommend_amendment_or_blend_alone:
          "Foliar evidence alone does not recommend amendment or blend.",
        foliar_do_not_execute_fertilization:
          "Foliar evidence does not execute fertilization.",
        foliar_do_not_execute_fertigation:
          "Foliar evidence does not execute fertigation.",
        foliar_do_not_infer_pest_or_disease_diagnosis_alone:
          "Foliar evidence alone does not confirm pest or disease diagnosis.",
        foliar_do_not_infer_water_stress_or_irrigation_need_alone:
          "Foliar evidence alone does not infer water stress or irrigation need.",
        foliar_do_not_relax_fao56_gates:
          "Foliar evidence does not relax FAO-56 gates.",
        foliar_do_not_replace_agronomist_interpretation:
          "Foliar evidence does not replace qualified agronomist interpretation.",
        foliar_do_not_infer_yield_loss_insurance_compliance_or_liability:
          "Foliar evidence does not infer yield loss, insurance, compliance or liability.",
        // Pest / disease scouting completeness safety notes
        pest_disease_scouting_completeness_does_not_confirm_diagnosis:
          "Scouting completeness does not confirm a pest or disease diagnosis.",
        pest_disease_scouting_completeness_does_not_authorize_treatment:
          "Scouting completeness does not authorize any phytosanitary treatment.",
        pest_disease_scouting_completeness_does_not_recommend_product_or_dose:
          "Scouting completeness does not recommend any pesticide, fungicide, herbicide, biological control product, active ingredient or dose.",
        pest_disease_scouting_completeness_does_not_instruct_spraying_or_application:
          "Scouting completeness does not instruct spraying, application or treatment.",
        pest_disease_scouting_completeness_does_not_replace_field_scouting_or_agronomist:
          "Scouting completeness does not replace field scouting, lab confirmation, local IPM guidance or qualified agronomic judgment.",
        pest_disease_scouting_completeness_does_not_infer_insurance_damage_or_liability:
          "Scouting completeness does not infer insurance, damage, yield loss or liability.",
        // Drought / water-stress safety notes
        drought_water_stress_do_not_execute_irrigation:
          "Drought / water-stress evidence does not execute irrigation.",
        drought_water_stress_do_not_schedule_irrigation_alone:
          "Drought / water-stress evidence alone does not schedule irrigation.",
        drought_water_stress_do_not_quantify_irrigation_alone:
          "Drought / water-stress evidence alone does not quantify irrigation.",
        drought_water_stress_do_not_infer_applied_irrigation:
          "Drought / water-stress evidence does not infer applied irrigation.",
        drought_water_stress_do_not_relax_fao56_gates:
          "Drought / water-stress evidence does not relax FAO-56 gates.",
        drought_water_stress_do_not_confirm_crop_or_yield_loss:
          "Drought / water-stress evidence does not confirm crop or yield loss.",
        drought_water_stress_do_not_infer_insurance_compliance_or_liability:
          "Drought / water-stress evidence does not infer insurance, compliance or liability.",
        // Vegetation indices safety notes
        vegetation_indices_do_not_infer_cause_alone:
          "Vegetation indices alone do not infer cause.",
        vegetation_indices_do_not_recommend_irrigation_alone:
          "Vegetation indices alone do not recommend irrigation.",
        vegetation_indices_do_not_recommend_fertilizer_product_or_dose_alone:
          "Vegetation indices alone do not recommend fertilizer product or dose.",
        vegetation_indices_do_not_recommend_pesticide_fungicide_or_herbicide_alone:
          "Vegetation indices alone do not recommend pesticide, fungicide or herbicide.",
        vegetation_indices_do_not_confirm_pest_disease_or_water_stress:
          "Vegetation indices do not confirm pest, disease or water stress.",
        vegetation_indices_do_not_relax_fao56_gates:
          "Vegetation indices do not relax FAO-56 gates.",
        vegetation_indices_do_not_execute_field_operations:
          "Vegetation indices do not execute field operations.",
        // Phenology safety notes
        phenology_do_not_execute_irrigation:
          "Phenology evidence does not execute irrigation.",
        phenology_do_not_execute_fertilization:
          "Phenology evidence does not execute fertilization.",
        phenology_do_not_recommend_fertilizer_product_or_dose_alone:
          "Phenology alone does not recommend fertilizer product or dose.",
        phenology_do_not_recommend_pesticide_fungicide_or_herbicide_alone:
          "Phenology alone does not recommend pesticide, fungicide or herbicide.",
        phenology_do_not_infer_disease_pest_or_water_stress_alone:
          "Phenology alone does not infer disease, pest or water stress.",
        phenology_do_not_update_harvest_status_automatically:
          "Phenology does not update harvest status automatically.",
        phenology_do_not_execute_sowing_planting_or_harvesting:
          "Phenology does not execute sowing, planting or harvesting.",
        phenology_do_not_infer_yield_loss_insurance_compliance_or_liability:
          "Phenology does not infer yield loss, insurance, compliance or liability.",
      },
      cropRotation: {
        title: "Crop rotation advisory",
        badge: "Advisory",
        disclaimer:
          "This is an advisory planning aid, not a seeding instruction. Validate locally with an agronomist.",
        humanReview: "Requires human review",
        confidence: "Confidence: {{level}}",
        confidenceLevel: { low: "low", moderate: "moderate" },
        readyForReview: "Ready for agronomist review",
        blocked: {
          title: "Crop rotation advisory blocked",
          missingInputs: "Required planning inputs are missing.",
          noRecommendation: "No crop recommendation generated.",
          missingLabel: "Missing planning inputs",
        },
        planning: {
          availableEvidence: "Available evidence",
          missing: "Missing",
          status: {
            ready_for_planning: "Ready for planning context",
            missing_required_inputs: "Missing required planning inputs",
            blocked: "Planning context blocked",
          },
        },
        requiredValidation: "Required validation",
        risksUnknowns: "Risks / unknowns",
        categories: {
          legume_cover_crop_options: "Legume cover crop options",
          cereal_cover_crop_options: "Cereal cover crop options",
          mixed_cover_crop_options: "Mixed cover crop options",
          soil_restoration_options: "Soil restoration options",
          erosion_control_options: "Erosion control options",
          fallow_or_rest_period_review: "Fallow / rest period review",
        },
        missingInputs: {
          harvest_status: "Harvest status",
          current_or_previous_crop: "Current or previous crop",
          next_crop_intention: "Next crop intention",
          post_harvest_objective: "Post-harvest objective",
          soil_evidence: "Soil evidence",
          planting_window: "Planting window",
          water_availability: "Water availability",
        },
        evidenceLabels: {
          harvested_confirmed: "Harvest confirmed",
          near_harvest_confirmed: "Near harvest confirmed",
          crop_active_confirmed: "Crop active confirmed",
          next_crop_declared: "Next crop declared",
          post_harvest_objective_declared: "Post-harvest objective declared",
          current_crop_known: "Current crop known",
          previous_crop_known: "Previous crop known",
          soil_analysis_present: "Soil analysis available",
          foliar_analysis_present: "Foliar analysis available",
          field_validation_or_scouting_present: "Field validation or scouting available",
          planting_window_known: "Planting window known",
          water_availability_known: "Water availability known",
          location_context_known: "Location context known",
        },
        declaredLabels: {
          harvest_status: "Producer declared harvest status",
          next_crop: "Producer declared next crop",
          post_harvest_objective: "Producer declared post-harvest objective",
        },
        capture: {
          title: "Answer missing input",
          harvestTitle: "Mark harvest status",
          harvestChoices: {
            active: "Still active",
            near_harvest: "Near harvest",
            harvested: "Harvested",
            uncertain: "Not sure",
          },
          nextCropTitle: "Declare next crop intention",
          nextCropPlaceholder: "e.g. barley",
          objectiveTitle: "Declare post-harvest objective",
          objectivePlaceholder: "Select an objective",
          objectiveChoices: {
            nitrogen_fixation: "Nitrogen fixation",
            erosion_control: "Erosion control",
            soil_restoration: "Soil restoration",
            weed_suppression: "Weed suppression",
            not_sure: "Not sure",
          },
          fieldEvidenceTitle: "Field evidence",
          markFieldValidation: "Mark field validation completed",
          markScouting: "Mark scouting completed",
          saveAnswer: "Save answer",
          answerSaved: "Answer saved",
          couldNotSave: "Could not save answer",
        },
      },
      missingEvidenceAccess: {
        title: "Update evidence",
        subtitle: "Open the relevant module to complete the missing evidence. Nothing is executed automatically.",
        openLabel: "Open",
        answerRequiredQuestions: "Answer required questions",
        noAccessAvailable: "Complete from the corresponding module",
        targets: {
          satellite_monitoring: "Satellite monitoring",
          weather_and_conditions: "Weather & conditions",
          irrigation_optimizer: "Irrigation optimizer",
          field_notebook: "Field notebook",
          fire_risk: "Fire risk",
          phenology: "Phenology",
          crop_cycle_planning: "Crop cycle / planning",
          drought_water_stress: "Drought & water stress",
          foliar_analysis: "Foliar analysis",
        },
      },
      helpCenter: {
        gaucho: "Gaucho",
        aiAgronomist: "AI Agronomist",
        launcherFarmer: "Open Gaucho — farm operations cockpit",
        launcherPublic: "Ask the AI Agronomist",
        helpCenter: "Help Center",
        gauchoSubtitle: "Supervised evidence-based farm operations assistant",
        agronomistSubtitle: "Scientific recommendations powered by AI",
        quickAnswers: "Quick answers & FAQs",
        helpAndFaqs: "Help & FAQs",
      },
      canonicalNetTarget: {
        sectionTitle: "Canonical NET irrigation target",
        reviewBadge: "Human review required",
        supervisedTargetTitle: "Supervised NET irrigation target",
        basisExplanation:
          "NET root-zone target derived from the canonical modelled water state and the reviewed management policy. It is not a gross applied depth.",
        noTargetProposed: "No NET irrigation target is proposed.",
        notTriggeredExplanation:
          "Management threshold not reached. No NET irrigation target is proposed.",
        statusLabel: {
          available: "Available for supervised review",
          not_triggered: "Not triggered",
          blocked: "Not available",
          unavailable: "Not available",
          system_error: "Not available",
          not_loaded: "Not loaded",
        },
        blockerReason: {
          generic: "Canonical evidence requirements are not satisfied yet.",
          system_error: "The canonical water state could not be read.",
          missing_canonical_water_state:
            "No canonical modelled water state exists for this parcel and day.",
          rejected_legacy_water_state:
            "The stored water state does not meet the canonical read requirements.",
          invalid_decision_day: "The decision day is not valid.",
          no_active_crop_season: "No active crop season is declared.",
          ambiguous_active_crop_season: "More than one active crop season is declared.",
          missing_reviewed_policy: "No reviewed management policy exists.",
          ambiguous_active_policy: "More than one active management policy exists.",
          invalid_policy_record: "The reviewed management policy is not valid.",
          policy_not_yet_valid: "The reviewed management policy is not yet in force.",
          policy_expired: "The reviewed management policy has expired.",
          exact_water_state_cutoff_unavailable:
            "Exact water-state evidence cutoff is not available yet. Gaucho will not quantify a current irrigation target until post-state rain and irrigation can be ordered safely against the canonical water state.",
          temporal_resolution_insufficient:
            "Rain and irrigation events cannot be ordered against the water state at the available time resolution.",
          post_state_water_event_requires_recompute:
            "Rain or irrigation occurred after the modelled water state; the balance must be recomputed first.",
          post_state_water_event_evidence_incomplete:
            "Rain and/or irrigation evidence after the modelled water state is incomplete.",
          stale_water_state:
            "The modelled water state is not current for the decision day.",
          missing_post_state_water_event_evidence:
            "Rain and irrigation evidence after the modelled water state is missing.",
          missing_root_zone_depletion:
            "Root-zone depletion (Dr) is not available in the canonical water state.",
          invalid_root_zone_depletion:
            "Root-zone depletion (Dr) in the canonical water state is not valid.",
          management_threshold_unavailable:
            "The readily available water threshold (RAW) is not available.",
          management_threshold_not_reached:
            "Root-zone depletion has not reached the reviewed management threshold.",
          missing_taw_for_target_policy_validation:
            "Total available water (TAW) is required to validate the target policy and is missing.",
          invalid_taw_for_target_policy_validation:
            "Total available water (TAW) is not valid for target-policy validation.",
          missing_target_policy: "No reviewed target policy is available.",
          invalid_target_policy: "The reviewed target policy is not valid.",
        },
        limitations: {
          net_root_zone_target_not_gross_applied_depth:
            "NET root-zone target — not a gross applied depth.",
          no_irrigation_duration: "Not an irrigation duration.",
          no_irrigation_schedule: "Not an irrigation schedule.",
          no_execution_command: "Not an execution command.",
          human_agronomic_review_required: "Human agronomic review is required.",
        },
      },
      waterStressSemantics: {
        sectionTitle: "Gaucho water-stress reading",
        disclaimer:
          "Read-only interpretation — does not execute or authorize irrigation.",
        statusLabel: {
          not_applicable_until_cycle_confirmed: "Not applicable",
          insufficient_evidence: "Insufficient evidence",
          stale: "Stale",
          blocked: "Blocked",
          low: "Low",
          elevated: "Elevated",
          high: "High",
        },
        categoryTitle: {
          satellite_water_stress: "Satellite: observed water stress",
          atmospheric_demand: "Weather: atmospheric demand",
          drought_risk_context: "Drought: risk context",
          fao56_irrigation_requirement: "FAO-56: irrigation requirement",
        },
        satellite_water_stress_insufficient_evidence:
          "Insufficient satellite evidence to classify water stress.",
        satellite_water_stress_stale:
          "Stale satellite signal — refresh evidence before deciding.",
        satellite_water_stress_not_applicable_until_cycle_confirmed:
          "Water-stress interpretation is not applicable until crop cycle / active crop is confirmed.",
        satellite_water_stress_low_recent_signal:
          "Satellite water-stress signal is low — this does not prove absence of stress.",
        satellite_water_stress_elevated_validate_in_field:
          "Elevated satellite water-stress signal — validate in the field.",
        satellite_vegetation_anomaly_validate_in_field:
          "Vegetation-index anomaly detected — validate cause in the field.",
        atmospheric_demand_insufficient_evidence:
          "Insufficient weather evidence to classify atmospheric demand.",
        atmospheric_demand_forecast_missing:
          "7-day weather forecast is missing — atmospheric demand cannot be classified.",
        atmospheric_demand_low_from_et0:
          "Atmospheric demand is low based on ET0 — keep monitoring.",
        atmospheric_demand_elevated_from_et0:
          "Elevated atmospheric demand from ET0/temperature — review trend and forecast.",
        atmospheric_demand_very_high_from_et0:
          "Very high atmospheric demand from ET0 — review forecast and validate in the field; not an irrigation instruction.",
        drought_risk_context_insufficient_evidence:
          "Drought risk context unavailable — evidence insufficient.",
        drought_risk_context_stale:
          "Drought risk context is stale — refresh before deciding.",
        drought_risk_context_low:
          "Drought risk context has no active risk — keep monitoring.",
        drought_risk_context_active_not_irrigation_instruction:
          "Drought / water-stress risk context — not an irrigation instruction.",
        fao56_irrigation_requirement_blocked:
          "FAO-56 calculation is not available yet — evidence is missing to review irrigation amount.",
        fao56_irrigation_requirement_blocked_missing_evidence:
          "FAO-56 calculation is not available — ET0 or ETc is missing to review irrigation amount.",
        fao56_irrigation_requirement_blocked_forecast_missing:
          "Quantified calculation is available for review. The zone-specific irrigation recommendation stays blocked until the 7-day weather forecast is available. No automatic execution.",
        fao56_irrigation_requirement_blocked_cycle_not_confirmed:
          "Quantified calculation is available for review. The zone-specific irrigation recommendation stays blocked until the crop cycle is confirmed. No automatic execution.",
        fao56_irrigation_requirement_blocked_gates_pending:
          "Quantified calculation is available for review. The zone-specific irrigation recommendation stays blocked until the crop cycle is confirmed and low-vigor zones are validated.",
        fao56_irrigation_requirement_not_applicable_until_cycle_confirmed:
          "FAO-56 requirement is not applicable until crop cycle / active crop is confirmed.",
        fao56_irrigation_requirement_available_for_review:
          "FAO-56 is available to review irrigation amount — does not execute irrigation automatically.",
        combined: {
          satellite_low_but_atmospheric_elevated:
            "Satellite stress is low, but atmospheric demand is elevated.",
          harvested_or_out_of_cycle_no_stress_not_applicable:
            "Not applicable until crop cycle / active crop is confirmed.",
          missing_evidence_generic:
            "Insufficient evidence to classify water stress.",
          stale_signal_generic:
            "Stale signal — refresh evidence before deciding.",
        },
        humanReview: {
          field_validation_required: "Requires field validation",
          producer_confirmation_required: "Requires producer confirmation",
          blocked_by_missing_evidence: "Blocked by missing evidence",
          not_applicable_until_cycle_confirmed:
            "Not applicable until crop cycle confirmation",
        },
      },
      moduleEvidenceAlignment: {
        sectionTitle: "Module evidence alignment",
        sectionSubtitle:
          "How each module's evidence is currently treated by Gaucho. Read-only — does not execute or authorize field operations.",
        modules: {
          vegetation_indices: "Advanced vegetation indices",
          ndvi_zones: "NDVI / vigor zones",
          weather_conditions: "Weather & conditions",
          phenology: "Phenology intelligence",
          gdd: "GDD (auxiliary farm tool)",
          crop_rotation_tools: "Crop rotation (agricultural tools)",
          crop_rotation_gaucho: "Crop rotation (Gaucho advisor)",
          drought_water_stress: "Drought / water-stress context",
          fao56_irrigation: "FAO-56 irrigation requirement",
        },
        status: {
          primary: "Primary evidence",
          auxiliary: "Auxiliary evidence",
          preliminary: "Preliminary (exploratory)",
          missing: "Missing",
          stale: "Stale",
          blocked: "Blocked",
          not_integrated: "Not integrated",
          not_applicable: "Not applicable",
        },
        messages: {
          vegetation_indices_available:
            "Vegetation indices are available as evidence. Cause requires field validation.",
          vegetation_indices_critical_signal:
            "Critical vegetation / vigor signal detected — validate the cause in the field.",
          vegetation_indices_missing:
            "No usable vegetation-index evidence for this parcel.",
          vegetation_indices_not_integrated:
            "Vegetation indices are not currently surfaced to Gaucho for this parcel.",
          ndvi_zones_available:
            "NDVI / vigor zones available — treat as spatial vigor variability.",
          ndvi_zones_missing: "NDVI / vigor zones are not available.",
          ndvi_zones_not_integrated:
            "NDVI / vigor zones are not currently surfaced to Gaucho.",
          weather_conditions_available:
            "Weather signals available (current conditions and/or forecast).",
          weather_conditions_missing:
            "Weather signals are not available for this parcel.",
          weather_risk_inconclusive_forecast_missing:
            "Weather risk not computed — the 7-day forecast is missing.",
          weather_risk_inconclusive_et0_missing:
            "Weather risk not computed — ET0 is missing.",
          phenology_confirmed:
            "Confirmed phenological stage from the phenology module.",
          phenology_not_configured_for_crop:
            "Phenology is not configured for this crop — stage is not confirmed.",
          gdd_auxiliary_tool:
            "GDD is available as an auxiliary farm tool. Gaucho does not yet use it to unlock phenology, FAO-56 irrigation, rotation or recommendations.",
          crop_rotation_tools_preliminary:
            "Preliminary rule-based rotation suggestions. Gaucho requires post-harvest objective, planting window, water availability and soil evidence before validating a recommendation.",
          crop_rotation_gaucho_available:
            "Gaucho crop-rotation advisory available for human review.",
          crop_rotation_gaucho_blocked_missing_inputs:
            "Gaucho crop-rotation advisory is blocked — required planning inputs are missing.",
          crop_rotation_gaucho_planning_missing:
            "Crop-rotation planning context is not available for this parcel.",
          drought_context_active:
            "Active drought / water-stress context — contextual only, not an irrigation instruction.",
          drought_context_available:
            "Drought / water-stress context is available with no active risk.",
          drought_context_missing:
            "Drought / water-stress context is not available.",
          drought_context_not_integrated:
            "Drought / water-stress context is not currently surfaced to Gaucho.",
          fao56_available_for_review:
            "FAO-56 irrigation calculation is available for human review. Does not execute irrigation.",
          fao56_blocked_missing_evidence:
            "FAO-56 blocked — ET0, ETc, forecast or Kc dual evidence is missing.",
          fao56_blocked_gates_pending:
            "FAO-56 pending — other required evidence is not complete.",
        },
        notes: {
          read_only_alignment: "Read-only alignment view — no writes, no gate relaxation.",
          does_not_execute_field_operations:
            "Does not execute irrigation, fertigation, spraying or machinery operations.",
          does_not_recommend_product_dose_or_active_ingredient:
            "Does not recommend products, doses, blends or active ingredients.",
          does_not_relax_fao56_gates: "Does not relax FAO-56 gates.",
          requires_field_validation: "Requires field validation.",
          vegetation_indices_do_not_diagnose_cause:
            "Vegetation indices alone do not confirm cause, disease, nutrient deficiency or irrigation need.",
          vegetation_indices_do_not_authorize_irrigation:
            "Vegetation indices alone do not authorize irrigation.",
          ndvi_zones_are_spatial_variability_not_confirmed_water_stress:
            "NDVI zones represent spatial variability, not confirmed water stress.",
          weather_risk_do_not_mislabel_vegetation_signal_as_weather:
            "A low NDVI factor is vegetation evidence, not necessarily weather risk.",
          phenology_do_not_infer_from_gdd_alone:
            "Do not infer phenology from GDD alone.",
          gdd_does_not_confirm_phenology: "GDD does not confirm phenology.",
          gdd_does_not_unblock_irrigation_gate:
            "GDD does not unblock the FAO-56 / irrigation gate.",
          gdd_does_not_unblock_pest_disease_windows:
            "GDD does not unblock pest / disease windows.",
          gdd_does_not_unblock_crop_rotation:
            "GDD does not unblock crop-rotation recommendations.",
          gdd_does_not_update_harvest_status:
            "GDD does not update harvest status.",
          drought_context_is_not_an_irrigation_instruction:
            "Drought / water-stress context is not an irrigation instruction.",
          fao56_does_not_execute_irrigation: "FAO-56 does not execute irrigation.",
          crop_rotation_tools_not_final_recommendation:
            "Agricultural-tools rotation is preliminary and not a final recommendation.",
          crop_rotation_final_requires_gaucho_gates:
            "Final crop rotation requires Gaucho's evidence gates (post-harvest objective, planting window, water availability, soil evidence).",
          crop_rotation_requires_human_review:
            "Crop rotation advisory requires human review.",
        },
      },
      userReadinessChecklist: {
        calculatedRecommendationBlocked: "Calculated \u00b7 recommendation blocked",
        sectionTitle: "What Gaucho needs from you",
        groups: {
          required: "Required from you",
          recommended: "Recommended evidence",
          why: "Why this matters",
        },
        status: {
          completed: "Completed",
          needed: "Needed",
          recommended: "Recommended",
          not_requested: "Not requested",
        },
        items: {
          harvest_status: "Harvest status",
          next_planned_crop: "Next planned crop",
          post_harvest_objective: "Post-harvest objective",
          planting_window: "Planting window",
          water_availability: "Water availability",
          recent_irrigation: "Recent irrigation activity",
          field_validation: "Field validation (only when requested)",
          soil_or_foliar_analysis: "Soil or foliar analysis",
          satellite_ndvi_refresh: "Satellite / NDVI refresh",
          fao56_irrigation_calculation: "FAO-56 irrigation calculation",
          weather_forecast: "Weather / forecast evidence",
          pest_disease_scouting: "Pest / disease scouting",
          fire_risk_context: "Fire-risk context",
        },
        summary: {
          allComplete:
            "All required producer inputs are complete for this window.",
          someNeeded:
            "To improve Gaucho's recommendation, update the items below.",
        },
        blocker: {
          fao56AndPlanning:
            "Gaucho is blocked mainly because FAO-56 irrigation evidence and crop planning inputs are incomplete.",
          fao56Only:
            "Gaucho is blocked mainly because FAO-56 irrigation evidence is incomplete.",
          planningOnly:
            "Gaucho is blocked mainly because crop planning inputs are incomplete.",
        },
        whyBody:
          "Gaucho cannot validate irrigation, crop rotation or risk priorities until the required information is complete.",
      },
      readiness: {
        sectionTitle: "Prepare Gaucho",
        sectionSubtitle:
          "Complete these data points to improve Gaucho's analysis. Missing data does not generate fake evidence — Gaucho keeps affected modules in review-only or not-connected states. Readiness does not unlock real-world execution.",
        howToStartTitle: "How to start with Gaucho",
        howToStartSteps: [
          "Create or select a real parcel.",
          "Confirm crop and season information.",
          "Check satellite and vegetation availability.",
          "Add soil/foliar evidence if you want fertility context.",
          "Run ML risk or economic analysis manually if you want risk context.",
          "Add field observations.",
          "Review Gaucho recommendations and Action Plan.",
          "Approve/reject L4 supervised packages only as manual review, not execution.",
        ],
        scoreLabel: "Readiness",
        levels: {
          basic: "Basic",
          partial: "Partial",
          strong: "Strong",
          blocked: "Blocked",
        },
        requiredLevels: {
          required_basic: "Required",
          required_advanced: "Required for advanced",
          recommended: "Recommended",
          optional: "Optional",
        },
        statuses: {
          available: "Available",
          missing: "Missing",
          not_connected: "Not connected",
          insufficient: "Insufficient",
          not_checked: "Not checked",
        },
        groups: {
          parcel_identity: "Parcel identity",
          crop_season: "Crop & season",
          satellite_context: "Satellite & vegetation",
          water_irrigation: "Water & irrigation",
          soil_fertility: "Soil & fertility",
          risk_economic: "Risk & economic",
          field_observations: "Field observations",
          reporting_traceability: "Reporting & traceability",
        },
        modulesLimited: "Modules limited by missing data",
        noModulesLimited: "No modules are currently limited by missing data.",
        safetyNote:
          "Readiness is informational only. It does not unlock evidence gates, execution or auto-run any paid analysis.",
      },
      actionPlan: {
        title: "Action plan",
        humanReviewBadge: "Requires human review",
        status: {
          proposed: "Proposed",
          accepted: "Accepted",
          in_progress: "In progress",
          completed: "Completed",
          dismissed: "Dismissed",
          expired: "Expired",
          blocked: "Blocked",
        },
        btn: {
          accept: "Accept",
          inProgress: "Mark in progress",
          completed: "Mark completed",
          dismiss: "Dismiss",
        },
        executionBlockedNotice:
          "Execution blocked — no lifecycle actions available.",
      },
      recommendationPresentation: {
        primaryTitle: "Priorities now",
        secondaryTitle: "Other recommendations",
        whyPrimary: "Why this matters now",
        reasons: {
          urgency_critical: "Required evidence is missing",
          urgency_high: "High operational relevance",
          urgency_medium: "Medium operational relevance",
          urgency_low: "Low operational relevance",
          urgency_informational: "Informational",
          user_actionable: "You can act on this",
          limited_evidence: "Limited / reference evidence",
          missing_required_evidence: "Missing required evidence",
          evidence_blocker: "Calculation blocked by missing evidence",
        },
      },
      operationalRecommendations: {
        title: "Gaucho Recommendations",
        // GAUCHO-PRIMARY-RECOMMENDATIONS-LIMIT-1 keys live under
        // advisor.farmOps.recommendationPresentation (see below).
        subtitle:
          "Evidence-gated recommendations linked to the current parcel action plan.",
        humanReviewBadge: "Requires human review",
        empty:
          "No recommendations yet. Complete required evidence and confirmations to unlock Gaucho's guidance.",
        evidenceUsed: "Evidence used",
        missingEvidence: "Missing evidence",
        linkedActions: "Linked actions",
        linkedActionsCount_one: "{{count}} linked action",
        linkedActionsCount_other: "{{count}} linked actions",
        linkedActionsNone: "None yet",
        nextStep: "Recommended next step",
        categories: {
          irrigation: "Irrigation",
          vegetation: "Vegetation",
          water_stress: "Water context",
          crop_rotation: "Crop rotation",
          pest_disease: "Pest & disease",
          fire_risk: "Fire risk",
          weather: "Weather",
          soil_foliar: "Soil & foliar",
          reporting: "Reporting",
          general_operations: "General operations",
        },
        statuses: {
          ready: "Ready",
          needs_input: "Needs input",
          blocked: "Blocked",
          review_required: "Review required",
        },
        titles: {
          irrigation_ready: "Review crop-water demand and current water state",
          irrigation_canonical_target_review:
            "Review the canonical NET irrigation target",
          irrigation_target_not_triggered: "No NET irrigation target proposed",
          irrigation_target_blocked: "Canonical NET irrigation target blocked",
          irrigation_target_unavailable: "Canonical NET irrigation target unavailable",
          irrigation_target_system_error: "Canonical NET irrigation target not readable",
          irrigation_blocked: "Complete irrigation evidence",
          vegetation_validate: "Validate vegetation signal in the field",
          water_context: "Review water context",
          crop_rotation_needs_input: "Complete crop rotation inputs",
          crop_rotation_review: "Review crop rotation plan",
          pest_scouting: "Scout pest / disease risk",
          fire_prevention: "Review fire prevention",
          soil_foliar_evidence: "Upload soil or foliar evidence",
          reporting_review: "Review compliance evidence",
        },
        summaries: {
          irrigation_ready:
            "FAO-56 crop-water-demand evidence is available for review. No irrigation application amount is currently available.",
          irrigation_canonical_target_review:
            "A canonical NET irrigation target is available for supervised human review. It is a NET root-zone target, not a gross applied depth, duration or schedule.",
          irrigation_target_not_triggered:
            "The canonical decision proposes no NET irrigation target: the reviewed management threshold has not been reached.",
          irrigation_target_blocked:
            "The canonical NET irrigation target is blocked. No application amount is available from any other source.",
          irrigation_target_unavailable:
            "No canonical NET irrigation target is available for this parcel and day.",
          irrigation_target_system_error:
            "The canonical NET irrigation target could not be resolved due to a read error.",
          irrigation_blocked:
            "Gaucho cannot support an irrigation decision until FAO-56 evidence is complete.",
          vegetation_validate:
            "Satellite evidence shows vegetation variability. The cause is not confirmed.",
          water_context:
            "Water context signals are present. They describe stress, not an irrigation decision.",
          crop_rotation_needs_input:
            "Rotation planning cannot advance until missing human inputs are provided.",
          crop_rotation_review:
            "Rotation planning inputs are complete. Review the planning guidance before deciding.",
          pest_scouting:
            "Risk indicators suggest scouting. Gaucho does not confirm a pest or disease outbreak.",
          fire_prevention:
            "Fire risk indicators are present. Review preventive actions and official sources.",
          soil_foliar_evidence:
            "No persisted soil or foliar evidence found for this parcel.",
          reporting_review:
            "Compliance and audit evidence is available. Review before generating a report.",
        },
        rationales: {
          irrigation_ready:
            "ET0 / ETc and Dual Kc evidence describe atmospheric demand, crop evapotranspiration and water-balance state. They do not by themselves define an irrigation application target.",
          irrigation_canonical_target_review:
            "The canonical supervised decision resolved a NET root-zone target from the modelled water state and the reviewed management policy. Gaucho copies it verbatim and adds no arithmetic.",
          irrigation_target_not_triggered:
            "The reviewed management threshold has not been reached, so the canonical decision proposes no NET target. ETc remains reference demand only.",
          irrigation_target_blocked:
            "The canonical decision is blocked by an unmet evidence requirement. Gaucho does not substitute an ETc-derived amount.",
          irrigation_target_unavailable:
            "The canonical decision could not be resolved for this parcel and day. No irrigation target exists.",
          irrigation_target_system_error:
            "The canonical water state could not be read. Gaucho fails closed and shows no target.",
          irrigation_blocked:
            "Gaucho does not relax the FAO-56 gate. Missing evidence keeps the irrigation decision blocked.",
          vegetation_validate:
            "NDVI, NDRE, vigor zones and anomalies indicate spatial variability only. Gaucho does not infer drought, nutrient deficiency, pest or disease from satellite alone.",
          water_context_ready:
            "Satellite soil moisture, drought context and atmospheric demand are informational. Any irrigation decision goes through the FAO-56 gate.",
          water_context_blocked:
            "Water context is informational only. The irrigation decision remains blocked while FAO-56 evidence is incomplete.",
          crop_rotation_needs_input:
            "Rotation planning requires human inputs such as harvest status, next planned crop, post-harvest objective, planting window and water availability.",
          crop_rotation_review:
            "Rotation planning guidance is planning-only. Gaucho does not recommend a species, seed mix or sowing execution.",
          pest_scouting:
            "Gaucho recommends field scouting or agronomic review. No product, active ingredient or dose is proposed.",
          fire_prevention:
            "Gaucho recommends reviewing preventive actions and official sources. Gaucho does not replace emergency services.",
          soil_foliar_evidence:
            "Fertilization and nutrition decisions require persisted soil or foliar evidence.",
          reporting_review:
            "Report generation is informational. Gaucho does not submit insurance, legal or PAC claims.",
        },
        nextSteps: {
          irrigation_review:
            "Review the canonical water state and any missing field evidence with an agronomist.",
          irrigation_review_canonical_target:
            "Review the canonical NET irrigation target with an agronomist before any irrigation is decided or applied.",
          irrigation_complete_fao56:
            "Complete FAO-56 evidence (ET0, ETc, dual Kc, 7-day forecast) or confirm no irrigation for this window.",
          vegetation_field_check:
            "Open the affected zone in the field and record a scouting or validation note.",
          water_review_context:
            "Review water context together with FAO-56 evidence in the Irrigation Optimizer.",
          crop_rotation_complete_inputs:
            "Confirm harvest status, declare the next planned crop and post-harvest objective, and complete planting window and water availability inputs.",
          crop_rotation_review_plan:
            "Open the crop rotation planning section and review the guidance with an agronomist.",
          pest_scouting:
            "Open Pest & Disease and record a scouting observation for the affected zone.",
          fire_official_review:
            "Review official fire risk sources (national civil protection / EFFIS) and preventive readiness.",
          soil_foliar_upload:
            "Upload a recent soil lab or foliar analysis to enable fertilization guidance.",
          reporting_review:
            "Open Reports Center to review available compliance and audit evidence.",
        },
        safety: {
          irrigation_no_execution:
            "No irrigation amount, schedule or execution is produced. Gaucho never opens valves, starts pumps or activates irrigation automatically.",
          irrigation_canonical_target_only:
            "Any NET irrigation target shown here is copied from the canonical supervised decision. Gaucho never recalculates it and never derives an application amount from ETc.",
          irrigation_canonical_target_not_loaded:
            "The canonical NET target decision was not loaded, so no application-target readiness is implied.",
          vegetation_no_cause_inferred:
            "Satellite evidence alone does not confirm cause. Do not infer drought, deficiency, pest or disease without field validation.",
          water_no_execution:
            "Water context is informational. It never triggers irrigation execution.",
          crop_rotation_no_species:
            "Gaucho does not recommend a specific crop, species or seed mix.",
          pest_no_treatment:
            "Gaucho never proposes a pesticide, fungicide, herbicide, active ingredient or application.",
          fire_no_emergency:
            "Gaucho does not issue emergency instructions or replace civil protection services.",
          soil_no_fertilizer:
            "Gaucho does not recommend a fertilizer product or dose without persisted soil or foliar evidence.",
          reporting_no_claim:
            "Gaucho does not submit insurance, legal or PAC claims automatically.",
        },
        progress: {
          label: "Progress",
          countsSuffix: "{{completed}}/{{total}}",
          summary: {
            no_linked_action: "No linked actions",
            not_started: "Not started",
            accepted: "Accepted",
            in_progress: "In progress",
            completed: "All actions completed",
            partially_completed: "Partially completed",
            dismissed: "All dismissed",
            blocked: "Blocked action",
            expired: "Expired action",
            mixed: "Mixed progress",
          },
        },
        progressStates: {
          no_linked_action: "No linked actions",
          not_started: "Not started",
          accepted: "Accepted",
          in_progress: "In progress",
          completed: "Completed",
          partially_completed: "Partially completed",
          dismissed: "Dismissed",
          blocked: "Blocked",
          expired: "Expired",
          mixed: "Mixed",
        },
        nextBestAction: {
          badge: "Suggested follow-up",
          labels: {
            record_field_observation: "Record field observation details",
            record_scouting_findings: "Record scouting findings",
            review_fao56_recommendation: "Review FAO-56 recommendation",
            review_uploaded_soil_foliar_analysis:
              "Review uploaded soil or foliar analysis",
            review_or_export_evidence_report:
              "Review or export evidence report",
            review_recommendation_open_status:
              "Review whether this recommendation remains open",
            review_missing_evidence: "Review missing evidence",
            review_timing_or_applicability: "Review timing or applicability",
            continue_in_progress_action: "Continue the in-progress action",
            start_linked_action: "Start by reviewing the linked action",
            wait_for_action_completion: "Complete or update the linked action",
            review_mixed_progress: "Review mixed action progress",
            no_safe_follow_up: "No safe follow-up available",
          },
          rationales: {
            record_field_observation:
              "Field validation is complete. The next safe step is to record what was observed.",
            record_scouting_findings:
              "Scouting is complete. The next safe step is to document findings.",
            review_fao56_recommendation:
              "Irrigation log confirmation is complete. Reviewing the FAO-56 recommendation is the next safe step.",
            review_uploaded_soil_foliar_analysis:
              "Soil or foliar evidence upload is complete. The next safe step is to review the uploaded analysis.",
            review_or_export_evidence_report:
              "Reporting review is complete. The next safe step is evidence review or export.",
            review_recommendation_open_status:
              "Linked work is closed, but Gaucho does not automatically close recommendations.",
            review_missing_evidence:
              "Linked work is blocked. Review the missing evidence and context.",
            review_timing_or_applicability:
              "Linked action expired. Review whether this recommendation still applies.",
            continue_in_progress_action:
              "Linked work is underway. Gaucho is waiting for completion evidence.",
            start_linked_action:
              "Linked actions have not started yet. Review them before starting.",
            wait_for_action_completion:
              "Linked action was accepted or partially completed. Complete or update it next.",
            review_mixed_progress:
              "Linked actions have mixed statuses. Human review is required.",
            no_safe_follow_up:
              "No safe follow-up is available for this recommendation.",
          },
          safety: {
            no_cause_inference:
              "Do not infer cause from a single field observation.",
            no_pest_disease_confirmation:
              "Do not confirm a pest or disease outbreak automatically.",
            no_treatment_product_dose:
              "Do not propose treatments, products or doses.",
            no_irrigation_execution:
              "Do not schedule or execute irrigation automatically.",
            no_fertilizer_product_dose:
              "Do not propose fertilizer products or doses without persisted analysis.",
            no_claim_or_legal_submission:
              "Do not submit insurance, legal or PAC claims automatically.",
            no_evidence_fabrication:
              "Do not fabricate evidence to unblock a gate.",
            no_gate_bypass: "Do not bypass evidence gates.",
            no_auto_recreation: "Do not recreate the linked action automatically.",
            no_auto_resolution:
              "Do not resolve the recommendation automatically.",
          },
        },
      },
      actionObservations: {
          title: "Field observations",
          subtitle:
            "Attach human evidence notes to in-progress or completed actions.",
          empty: "No human observations recorded yet.",
          add: "Add field observation",
          noteLabel: "Observation note",
          typeLabel: "Observation type",
          severityLabel: "Severity",
          photoReferenceLabel: "Optional photo reference",
          save: "Save observation",
          saving: "Saving…",
          saved: "Observation saved",
          attachedBadge: "Human observation attached",
          humanEvidenceAttached: "Human evidence attached",
          safetyNotice:
            "Observations are human evidence notes. Gaucho does not infer causes or execute actions from them.",
          errors: {
            statusNotAllowed:
              "Observations can only be attached to in-progress or completed actions.",
            noteTooShort: "Observation note is too short (minimum 3 characters).",
            noteTooLong: "Observation note is too long (maximum 1200 characters).",
            photoReferenceTooLong:
              "Photo reference is too long (maximum 500 characters).",
          },
          types: {
            field_note: "Field note",
            scouting_note: "Scouting note",
            water_context_note: "Water context note",
            soil_foliar_note: "Soil or foliar note",
            reporting_note: "Reporting note",
            general_note: "General note",
          },
          severities: {
            unspecified: "Unspecified",
            low: "Low",
            medium: "Medium",
            high: "High",
          },
          safety: {
            no_cause_inference:
              "Do not infer cause from a single field observation.",
            no_pest_disease_confirmation:
              "Do not confirm a pest or disease outbreak automatically.",
            no_treatment_product_dose:
              "Do not propose treatments, products or doses.",
            no_irrigation_execution:
              "Do not schedule or execute irrigation automatically.",
            no_fao56_gate_bypass: "Do not bypass FAO-56 evidence gates.",
            no_fertilizer_product_dose:
              "Do not propose fertilizer products or doses without persisted analysis.",
            no_nutrient_diagnosis_without_analysis:
              "Do not diagnose nutrient status without a persisted analysis.",
            no_claim_or_legal_submission:
              "Do not submit insurance, legal or PAC claims automatically.",
            no_auto_resolution:
              "Do not resolve the recommendation automatically.",
          },
      },
        observationSummary: {
          title: "Human observation summary",
          badge: "Human observation summary",
          empty: "No linked human observations yet.",
          count_one: "{{count}} observation recorded",
          count_other: "{{count}} observations recorded",
          latest: "Latest observation",
          notes: "Recorded notes",
          severity: "Severity",
          attachedBadge: "Human evidence attached",
          noteLabel: "Observation note",
          types: {
            field_note: "Field note",
            scouting_note: "Scouting note",
            water_context_note: "Water context note",
            soil_foliar_note: "Soil or foliar note",
            reporting_note: "Reporting note",
            general_note: "General note",
          },
          severities: {
            unspecified: "Unspecified",
            low: "Low",
            medium: "Medium",
            high: "High",
          },
          summaries: {
            vegetation:
              "User-recorded field notes linked to the vegetation review.",
            water_stress:
              "User-recorded notes linked to the water context review.",
            irrigation:
              "User-recorded notes linked to the irrigation review.",
            pest_disease:
              "User-recorded scouting notes linked to the pest and disease review.",
            soil_foliar:
              "User-recorded notes linked to the soil or foliar evidence review.",
            reporting:
              "User-recorded notes linked to the reporting review.",
            crop_rotation:
              "User-recorded notes linked to the crop rotation review.",
            fire_risk:
              "User-recorded notes linked to the fire risk review.",
            weather:
              "User-recorded notes linked to the weather review.",
            general:
              "User-recorded notes linked to this recommendation.",
          },
          safety: {
            no_cause_inference:
              "Gaucho does not infer causes from human observations.",
            no_irrigation_execution:
              "Gaucho does not schedule or start irrigation from human observations.",
            no_fao56_gate_bypass:
              "Human observations do not bypass FAO-56 evidence gates.",
            no_pest_disease_confirmation:
              "Gaucho does not confirm a pest or disease outbreak from human observations.",
            no_treatment_product_dose:
              "Gaucho does not propose treatments, products or doses.",
            no_fertilizer_product_dose:
              "Gaucho does not propose fertilizer products or doses from human observations.",
            no_nutrient_diagnosis_without_analysis:
              "Gaucho does not diagnose nutrient status without a persisted analysis.",
            no_claim_or_legal_submission:
              "Gaucho does not submit insurance, legal or PAC actions from human observations.",
            no_sowing_or_planting_execution:
              "Gaucho does not schedule sowing or planting from human observations.",
            no_emergency_decision:
              "Gaucho does not make emergency decisions from human observations.",
            no_automatic_weather_action:
              "Gaucho does not act on weather signals automatically.",
            no_auto_resolution:
              "Gaucho does not resolve the recommendation automatically.",
          },
        },
        supervisedActionPackage: {
          title: "Supervised action package",
          subtitle:
            "Structured package prepared for human review. Not automatic. Approval required.",
          badge: "L4 · Supervised preparation",
          autonomyLevel: "L4 supervised action preparation",
          approvalRequired: "Approval required",
          linkedRecommendation: "Linked recommendation",
          linkedAction: "Linked action",
          evidenceUsed: "Evidence used",
          missingEvidence: "Missing evidence",
          humanObservationCount_one: "{{count}} linked human observation",
          humanObservationCount_other: "{{count}} linked human observations",
          canBeApproved: "Eligible for manual approval",
          reviewOnly: "Review only — approval blocked for this category",
          status: {
            draft: "Draft",
            review_required: "Review required",
            blocked: "Blocked",
          },
          allowedReviewActions: {
            approve_for_manual_followup: "Approve for manual follow-up",
            reject: "Reject",
            mark_blocked: "Mark blocked",
          },
          blockedReasons: {
            no_linked_action:
              "No linked action available for this recommendation.",
            action_not_ready:
              "Linked action is not in an accepted, in-progress or completed state.",
            recommendation_blocked: "Recommendation is currently blocked.",
            critical_missing_evidence:
              "Critical evidence is missing. Supply the required inputs first.",
          },
          categories: {
            vegetation: "Vegetation",
            water_stress: "Water context",
            irrigation: "Irrigation",
            pest_disease: "Pest and disease",
            soil_foliar: "Soil and foliar",
            reporting: "Reporting",
            crop_rotation: "Crop rotation",
            fire_risk: "Fire risk",
            weather: "Weather",
            general_operations: "General operations",
          },
          titles: {
            vegetation: "Vegetation field follow-up package",
            water_stress: "Water context review package",
            irrigation: "FAO-56 irrigation review package",
            pest_disease: "Scouting review package",
            soil_foliar: "Soil and foliar evidence review package",
            reporting: "Report review package",
            crop_rotation: "Crop rotation planning review package",
            fire_risk: "Preventive fire-risk review package",
            weather: "Weather review package",
            general_operations: "General manual review package",
          },
          summaries: {
            vegetation:
              "Prepared manual field follow-up for the human to review. Not automatic.",
            water_stress:
              "Prepared water-context review for the human. No irrigation is scheduled.",
            irrigation:
              "Prepared FAO-56 review for the human. No pump, valve or volume is proposed.",
            pest_disease:
              "Prepared scouting review for the human. No confirmation, no treatment.",
            soil_foliar:
              "Prepared lab/evidence review for the human. No fertilizer product or dose.",
            reporting:
              "Prepared report review for the human. No legal, insurance or PAC submission.",
            crop_rotation:
              "Prepared planning review for the human. No sowing or planting instruction.",
            fire_risk:
              "Prepared preventive review for the human. No emergency decision.",
            weather:
              "Prepared weather review for the human. No automatic weather action.",
            general_operations:
              "Prepared manual review package for the human.",
          },
          safety: {
            not_automatic: "Not automatic.",
            requires_human_review: "Requires human review.",
            approval_required: "Approval required before any follow-up.",
            no_autonomous_action: "No autonomous action.",
            no_real_execution: "No real-world execution from this package.",
            no_cause_inference: "Does not infer agronomic cause.",
            no_irrigation_execution:
              "Does not schedule or start irrigation.",
            no_fao56_gate_bypass: "Does not bypass FAO-56 evidence gates.",
            no_pest_disease_confirmation:
              "Does not confirm a pest or disease outbreak.",
            no_treatment_product_dose:
              "Does not propose treatments, products or doses.",
            no_fertilizer_product_dose:
              "Does not propose fertilizer products or doses.",
            no_nutrient_diagnosis_without_analysis:
              "Does not diagnose nutrient status without a persisted analysis.",
            no_claim_or_legal_submission:
              "Does not submit insurance, legal or PAC actions.",
            no_sowing_or_planting_execution:
              "Does not schedule sowing or planting.",
            no_emergency_decision: "Does not make emergency decisions.",
            no_automatic_weather_action:
              "Does not act on weather signals automatically.",
            no_auto_resolution:
              "Does not resolve the recommendation automatically.",
            review_only_sensitive_category:
              "Review only. This category is not eligible for manual approval in this preparation layer.",
          },
        },
        supervisedActionReview: {
          title: "Human review audit",
          subtitle:
            "Records a human review decision only. No automatic action is triggered. Manual follow-up only.",
          latestDecision: "Latest decision",
          historyCount_one: "{{count}} review record",
          historyCount_other: "{{count}} review records",
          decisionNoteLabel: "Reviewer note (optional, max 1200 characters)",
          decisionNotePlaceholder:
            "Add a short human note about this review decision.",
          recordDecision: "Record decision",
          saving: "Saving…",
          saved: "Saved.",
          error:
            "Could not save the review decision. No action was taken. Please try again.",
          decisions: {
            approve_for_manual_followup: "Approve manual follow-up",
            reject: "Reject package",
            mark_blocked: "Mark package blocked",
          },
          blockedReasons: {
            approvalNotAllowed:
              "Manual follow-up approval is not allowed for this package.",
            noteTooLong:
              "Reviewer note is too long. Please shorten it to 1200 characters or less.",
          },
          safety: {
            human_review_audit_only: "Human review audit only.",
            no_automatic_action: "No automatic action is triggered.",
            review_only_no_irrigation_action:
              "Review only. Does not schedule or start irrigation.",
            review_only_no_treatment_action:
              "Review only. Does not propose or start any treatment.",
            review_only_no_fertilizer_action:
              "Review only. Does not propose or start any fertilizer plan.",
            review_only_no_submission_action:
              "Review only. Does not send any insurance, legal or PAC submission.",
            review_only_no_emergency_action:
              "Review only. Does not raise or dispatch an emergency response.",
          },
        },
      moduleEvidenceRegistry: {
        sectionTitle: "Module evidence registry",
        sectionSubtitle:
          "Central registry that maps SentinelCrop modules to Gaucho evidence domains, safety classes and integration levels. Read-only. Does not execute field operations, propose products or doses, and does not authorize irrigation, fertilization, emergency, insurance, legal or PAC actions.",
        modules: {
          drought_water_stress: "Drought and water stress",
          ml_risk_analysis: "ML risk analysis",
          economic_risk_impact: "Economic risk impact",
          nitrogen_optimizer: "Nitrogen optimizer",
          pk_fertilization_optimizer: "P and K fertilization optimizer",
          irrigation_optimizer: "Irrigation optimizer",
          advanced_vegetation_analysis: "Advanced vegetation analysis",
          satellite_view: "Satellite view",
          crop_seasons: "Crop seasons",
          phenology_gdd: "Phenology and GDD",
          soil_foliar_analysis: "Soil and foliar analysis",
          reports_center: "Reports center",
          fire_risk: "Fire risk",
          pest_disease: "Pest and disease risk",
          crop_rotation_advisor: "Crop rotation advisor",
          parcel_memory: "Parcel memory",
          field_activities: "Field activities",
        },
        statuses: {
          working: "Working",
          partially_working: "Partially working",
          broken: "Broken",
          not_tested: "Not tested",
        },
        integrationLevels: {
          not_integrated: "Not integrated into Gaucho",
          auxiliary_visible: "Auxiliary and visible only",
          primary_evidence: "Primary evidence input",
          creates_recommendation: "Can drive a recommendation",
          creates_action_plan: "Can create an Action Plan row",
          influences_progress: "Can influence progress state",
          influences_nba: "Can influence the next best action suggestion",
          l4_supervised_package: "Can appear in a supervised action package",
          l4_audit_included: "Included in supervised review audit trail",
        },
        safetyClasses: {
          safe_informational: "Safe informational context",
          evidence_gated: "Evidence gated",
          review_only: "Review only. No automatic action.",
          sensitive_agronomic:
            "Sensitive agronomic context. Review only. Does not propose products or doses.",
          blocked_from_approval:
            "Blocked from supervised approval. Human follow-up only.",
          non_binding_risk_estimate:
            "Non-binding risk estimate. Not an insurance, legal or PAC statement.",
        },
        evidenceDomains: {
          water: "Water",
          vegetation: "Vegetation",
          risk: "Risk",
          economic: "Economic",
          fertility: "Fertility",
          irrigation: "Irrigation",
          phenology: "Phenology",
          crop_lifecycle: "Crop lifecycle",
          reporting: "Reporting",
          fire: "Fire",
          pest_disease: "Pest and disease",
          memory: "Memory",
          field_activity: "Field activity",
          general: "General",
        },
        usageSummaries: {
          drought_water_stress_current:
            "Drought and water stress is used as auxiliary context only. It does not schedule or authorize irrigation.",
          drought_water_stress_target:
            "Planned use is to drive a water-context review recommendation, still without any irrigation execution.",
          ml_risk_current:
            "ML risk analysis is not integrated into Gaucho today. Its outputs do not affect recommendations or gates.",
          ml_risk_target:
            "Planned use is to display a non-binding risk context for human review. It does not confirm damage or trigger claims.",
          economic_risk_current:
            "Economic risk impact is not integrated into Gaucho today. Its outputs do not affect recommendations or gates.",
          economic_risk_target:
            "Planned use is to display a non-binding economic context for human review. It does not represent an insurance, legal or PAC decision.",
          nitrogen_current:
            "Nitrogen optimizer is not integrated into Gaucho today. It does not propose products, doses or applications through the advisor.",
          nitrogen_target:
            "Planned use is to surface review-only fertility context. It will never propose a product, dose or application through the advisor.",
          pk_current:
            "P and K optimizer is not integrated into Gaucho today. It does not propose products, doses or applications through the advisor.",
          pk_target:
            "Planned use is to surface review-only fertility context. It will never propose a product, dose or application through the advisor.",
          irrigation_current:
            "Irrigation optimizer context is visible only. It does not schedule or start irrigation.",
          irrigation_target:
            "Planned use is to expose review-only irrigation context. It will never schedule or start irrigation.",
          vegetation_current:
            "Advanced vegetation analysis is used as primary vegetation evidence. Cause is not inferred from satellite alone.",
          vegetation_target:
            "Planned use continues as primary vegetation evidence with field validation required for cause.",
          satellite_current:
            "Satellite view provides informational imagery context. Cause is not inferred from satellite alone.",
          satellite_target:
            "Planned use continues as informational imagery context.",
          crop_seasons_current:
            "Crop seasons provide lifecycle context that is visible only.",
          crop_seasons_target:
            "Planned use is to become primary lifecycle evidence with human confirmation.",
          phenology_gdd_current:
            "Phenology and GDD are auxiliary. GDD does not unlock phenology, FAO-56 or any other gate today.",
          phenology_gdd_target:
            "Planned use continues as auxiliary. Any gate use requires an explicit, separately reviewed change.",
          soil_foliar_current:
            "Soil and foliar analysis is visible only. It does not diagnose nutrient status or propose products or doses without a persisted analysis.",
          soil_foliar_target:
            "Planned use is review-only fertility context. It will never propose products or doses without a persisted analysis.",
          reports_current:
            "Reports center is visible only. It does not submit insurance, legal or PAC actions.",
          reports_target:
            "Planned use continues as review-only documentation. It will never submit insurance, legal or PAC actions.",
          fire_current:
            "Fire risk is visible only. It does not raise or dispatch an emergency response.",
          fire_target:
            "Planned use continues as review-only risk context. It will never raise or dispatch an emergency response.",
          pest_disease_current:
            "Pest and disease risk is visible only. It does not propose products, doses or applications.",
          pest_disease_target:
            "Planned use continues as review-only risk context. Control decisions stay with the agronomist.",
          crop_rotation_current:
            "Crop rotation advisor is visible only. It does not sow, plant or execute any field operation.",
          crop_rotation_target:
            "Planned use is to drive a rotation advisory recommendation for human review. It will never sow or plant.",
          parcel_memory_current:
            "Parcel memory provides historical context that is visible only.",
          parcel_memory_target:
            "Planned use is to become primary historical evidence, still without gate effects.",
          field_activities_current:
            "Field activities provide human-recorded operational evidence that is visible only.",
          field_activities_target:
            "Planned use is to become primary operational evidence, still without automatic execution.",
        },
        notes: {
          drought_water_stress:
            "Drought and water stress is auxiliary today. Any water decision requires human review.",
          ml_risk_analysis:
            "ML risk outputs are non-binding estimates. They do not confirm damage and do not trigger claims.",
          economic_risk_impact:
            "Economic risk outputs are non-binding estimates. They do not represent an insurance, legal or PAC decision.",
          nitrogen_optimizer:
            "Nitrogen guidance is review-only. Gaucho does not propose products, doses or applications.",
          pk_fertilization_optimizer:
            "P and K guidance is review-only. Gaucho does not propose products, doses or applications.",
          irrigation_optimizer:
            "Irrigation context is review-only. Gaucho does not schedule or start irrigation.",
          advanced_vegetation_analysis:
            "Vegetation indices are evidence. Cause requires field validation.",
          satellite_view:
            "Satellite imagery is informational. Cause requires field validation.",
          crop_seasons:
            "Season data provides lifecycle context. It does not unlock agronomic gates on its own.",
          phenology_gdd:
            "GDD is auxiliary. It does not unlock phenology, FAO-56 or any other gate today.",
          soil_foliar_analysis:
            "Soil and foliar analysis requires human review. Gaucho does not diagnose nutrient status without a persisted analysis.",
          reports_center:
            "Reports are review-only documents. Gaucho does not submit insurance, legal or PAC actions.",
          fire_risk:
            "Fire risk is review-only. Gaucho does not raise or dispatch an emergency response.",
          pest_disease:
            "Pest and disease risk is review-only. Gaucho does not propose products, doses or applications.",
          crop_rotation_advisor:
            "Rotation advisory is review-only. Gaucho does not sow, plant or execute any field operation.",
          parcel_memory:
            "Parcel memory is historical context only.",
          field_activities:
            "Field activities are human-recorded evidence. Gaucho does not execute activities on your behalf.",
        },
        blockedUses: {
          no_irrigation_execution:
            "Does not schedule or start irrigation.",
          no_fao56_gate_bypass: "Does not bypass FAO-56 evidence gates.",
          no_gate_effect: "Does not affect Gaucho evidence gates today.",
          no_auto_recommendation:
            "Does not create a recommendation automatically.",
          no_product_dose_recommendation:
            "Does not propose products, doses or applications.",
          no_fertilizer_application_execution:
            "Does not execute or schedule a fertilizer application.",
          no_nutrient_diagnosis_without_analysis:
            "Does not diagnose nutrient status without a persisted analysis.",
          no_cause_inference_from_satellite:
            "Does not infer cause from satellite alone.",
          no_claim_or_legal_submission:
            "Does not submit insurance, legal or PAC actions.",
          no_emergency_action:
            "Does not raise or dispatch an emergency response.",
          no_product_or_dose:
            "Does not propose products, doses or applications.",
          no_sowing_planting_execution:
            "Does not sow, plant or execute any field operation.",
          no_auto_execution: "Does not execute activities automatically.",
          blocked_from_approval:
            "Blocked from supervised approval. Human follow-up only.",
          no_phenology_gate_unlock:
            "Does not unlock phenology gates today.",
        },
        allowedFutureUses: {
          provide_water_context: "Provide water context for human review.",
          trigger_water_review_recommendation:
            "Trigger a water-context recommendation for human review.",
          display_non_binding_risk_context:
            "Display non-binding risk context for human review.",
          display_non_binding_economic_context:
            "Display non-binding economic context for human review.",
          surface_review_only_fertility_context:
            "Surface review-only fertility context.",
          surface_review_only_irrigation_context:
            "Surface review-only irrigation context.",
          provide_vegetation_evidence:
            "Provide vegetation evidence input.",
          display_imagery_context: "Display imagery context.",
          provide_lifecycle_context: "Provide crop lifecycle context.",
          display_gdd_auxiliary_context:
            "Display GDD as auxiliary context.",
          generate_review_documentation:
            "Generate review-only documentation.",
          display_fire_risk_context: "Display fire risk context.",
          display_pest_risk_context: "Display pest and disease risk context.",
          provide_rotation_advisory_for_review:
            "Provide rotation advisory for human review.",
          provide_historical_context: "Provide historical context.",
          record_human_operational_evidence:
            "Record human operational evidence.",
        },
      },
      fertilityReviewContext: {
        title: "Fertility context (review only)",
        subtitle:
          "Review-only fertility context for the current parcel. Gaucho does not recommend fertilizer products, doses or application rates.",
        nitrogen: "Nitrogen context",
        phosphorusPotassium: "Phosphorus & Potassium context",
        soilAnalysis: "Soil analysis",
        foliarAnalysis: "Foliar analysis",
        labAnalysis: "Lab analysis date",
        cropStage: "Crop stage",
        nutrientsFlagged: "Nutrients flagged for review",
        reviewOnly: "Review only",
        requiresAgronomistReview: "Requires agronomist review",
        empty: "No fertility context available.",
        notConnected:
          "Fertility modules are not connected to Gaucho yet. Open the Nitrogen Optimizer, P&K Optimizer and Soil/Foliar Analysis modules for the full view.",
        insufficientData: "Fertility signals do not have enough data yet.",
        statuses: {
          available: "Available",
          insufficient_data: "Insufficient data",
          not_available: "Not available",
          not_connected: "Not connected",
          error: "Data source error",
          connected_review_only: "Connected · review only",
        },
        connectedEvidenceNote:
          "This evidence exists and is connected to the Fertility Context, but it is not verified here as laboratory-confirmed evidence. It stays review-only and does not unlock fertility recommendations.",
        soilEvidenceTiers: {
          producer_lab_attributed: "Producer lab-attributed · review only",
          producer_declared: "Producer-declared · unverified",
          unattributed: "Modelled reference · not producer evidence",
          absent: "Not available",
        },
        unattributedSoilNote:
          "The stored soil record for this parcel has no producer or laboratory attribution (no lab name, sampling date, sampling depth or lab document). It is modelled reference data only and is not counted as producer soil evidence.",
        summary: {
          both: "Nitrogen and P&K context are visible as review-only signals.",
          nitrogenOnly:
            "Nitrogen context is visible as a review-only signal. P&K context is not connected.",
          pkOnly:
            "P&K context is visible as a review-only signal. Nitrogen context is not connected.",
          insufficient:
            "Fertility signals do not have enough data yet. Qualified agronomic review is required.",
          notConnected:
            "Fertility modules are not connected to Gaucho yet.",
          empty: "No fertility context available.",
        },
        missing: {
          nitrogen: "Nitrogen Optimizer output is not connected to Gaucho.",
          pk: "P&K Fertilization Optimizer output is not connected to Gaucho.",
          soilAnalysis: "Not available",
          foliarAnalysis: "Not available",
          soilOrFoliarEvidence:
            "Soil or foliar evidence is required for fertility decisions.",
        },
        safety: {
          title: "Safety notice",
          reviewOnly: "Fertility context is review-only.",
          noProductDoseApplicationRate:
            "Gaucho does not recommend fertilizer products, doses or application rates.",
          requiresLabAndAgronomistReview:
            "Soil or foliar evidence and qualified agronomic review are required.",
          noSatelliteOnlyDeficiencyInference:
            "No nutrient deficiency is inferred from satellite data alone.",
        },
      },
      riskEconomicContext: {
        title: "Risk and economic context",
        subtitle:
          "Non-binding decision-support context for the current parcel. Review-only.",
        mlRisk: "ML risk context",
        economicImpact: "Economic impact context",
        confidence: "Model confidence",
        historicalCoverage: "Historical coverage",
        claimsRecords: "Historical claim records",
        yieldRecords: "Historical yield records",
        estimatedImpact: "Estimated economic impact",
        estimatedRange: "Estimated range",
        nonBinding: "Non-binding",
        requiresHumanReview: "Requires human review",
        empty: "No risk or economic context available.",
        notConnected:
          "Risk and economic modules are not connected to Gaucho yet. Open the ML Risk Analysis and Economic Risk Impact modules for the full view.",
        confidenceLabels: {
          high: "High",
          medium: "Medium",
          low: "Low",
          unknown: "Unknown",
        },
        riskLevel: {
          title: "Risk level",
          low: "Low",
          medium: "Medium",
          high: "High",
          unknown: "Unknown",
        },
        impactLevel: {
          title: "Impact level",
          low: "Low",
          medium: "Medium",
          high: "High",
          unknown: "Unknown",
        },
        statuses: {
          available: "Available",
          insufficient_data: "Insufficient data",
          not_available: "Not available",
          error: "Data source error",
          not_connected: "Not connected",
        },
        summary: {
          both: "ML risk and economic impact context are available as review-only signals.",
          mlOnly:
            "ML risk context is available as a review-only signal. Economic impact context is not connected.",
          economicOnly:
            "Economic impact context is available as a review-only signal. ML risk context is not connected.",
          insufficient:
            "Risk and economic signals do not have enough data yet. Review is required before any decision.",
          notConnected:
            "Risk and economic modules are not connected to Gaucho yet.",
          empty: "No risk or economic context available.",
        },
        missing: {
          mlRisk: "No ML risk context is currently connected to Gaucho.",
          economicImpact:
            "No economic impact context is currently connected to Gaucho.",
        },
        safety: {
          title: "Safety notice",
          decisionSupportOnly:
            "Risk and economic impact are decision-support estimates only.",
          doesNotConfirmLoss:
            "They do not confirm losses and do not validate claims.",
          noClaimSubmission:
            "No claim, legal, insurance or emergency action is submitted.",
          requiresQualifiedReview:
            "Requires qualified human review before any decision.",
        },
      },
    },
    waterDeficit: {
      reviewOnly: "Review only",
      supporting: "Evidence compatible with a water deficit",
      contradicting: "Evidence that does not indicate a water deficit",
      modifiers: "Context considered",
      reviewActions: "Suggested review steps",
      missing: "Missing evidence",
      referenceDemandNote:
        "FAO-56 reference crop-water demand (Single Kc): {{etc}} mm/day. This is demand, not a measured deficit.",
      forecastNote:
        "Forecast precipitation for the covered window: {{mm}} mm (up to {{days}}).",
      providerReferenceNote:
        "NASA POWER root-zone wetness is shown as external reference only. It is not canonical evidence, it does not take part in the reasoning, and its own stress level and irrigation advice are discarded.",
      amountGuidanceNote:
        "Irrigation amounts and supervised irrigation recommendations remain governed by the FAO-56 irrigation readiness gate. Gaucho never schedules or executes irrigation.",
      pattern: {
        CONVERGING_WATER_DEFICIT_CONCERN: {
          headline: "Independent sources converge on a possible water deficit",
          reasoning:
            "More than one independent source is compatible with a water deficit and none contradicts it. This does not prove a root-zone deficit; validate in the field before any irrigation decision.",
        },
        PARTIAL_WATER_DEFICIT_CONCERN: {
          headline: "One direct source is compatible with a water deficit",
          reasoning:
            "A single direct source is compatible with a water deficit. The remaining sources have not confirmed it.",
        },
        SATELLITE_SIGNAL_CAUSE_UNRESOLVED: {
          headline: "Satellite signal detected, cause not resolved",
          reasoning:
            "The canopy signal is compatible with water stress, but the root-zone water balance is not available, so the cause cannot be attributed to water. Nutrition, pest, disease and management causes are not ruled out.",
        },
        DEMAND_WITHOUT_STRESS_SIGNAL: {
          headline: "Reference crop-water demand available, no stress signal",
          reasoning:
            "FAO-56 reference demand is available, but no direct source currently indicates crop water stress. Demand alone is never a deficit.",
        },
        MIXED_OR_CONFLICTING_WATER_EVIDENCE: {
          headline: "Water evidence needs reconciliation",
          reasoning:
            "Sources disagree, or a recent water input coexists with a persisting deficit signal. A recent water input does not prove the deficit was resolved.",
        },
        NO_CURRENT_CONVERGING_WATER_DEFICIT_SIGNAL: {
          headline: "No converging water deficit signal right now",
          reasoning:
            "Every resolved direct source is currently consistent with an adequate water status.",
        },
        INSUFFICIENT_EVIDENCE: {
          headline: "Not enough water evidence to reason",
          reasoning:
            "No direct water source resolved for this parcel. Complete the missing evidence in the existing modules.",
        },
      },
      channel: {
        single_kc_reference_demand: "FAO-56 reference crop-water demand (Single Kc)",
        canonical_root_zone_balance: "FAO-56 root-zone water balance (Dual Kc)",
        modelled_reference_soil_water_balance: "Modelled soil water balance",
        satellite_water_stress: "Sentinel-2 canopy water signal (NDWI/NDVI)",
        drought_context: "Regional drought context",
        water_alerts: "Recorded water alerts",
      },
      modifier: {
        recent_precipitation_observed: "Precipitation observed in the recorded period",
        explicit_zero_precipitation_observed: "No precipitation recorded in the observed period",
        observed_precipitation_unknown: "Observed precipitation unknown for this period",
        near_term_precipitation_expected: "Precipitation expected in the forecast window",
        no_precipitation_forecast_for_covered_period:
          "No precipitation forecast for the covered window",
        forecast_precipitation_unknown: "Forecast precipitation unavailable or incomplete",
        recent_irrigation_observed_response_not_yet_verified:
          "Recent irrigation recorded; the crop response has not been verified yet",
        applied_irrigation_uncertain: "Applied irrigation reported as uncertain",
        no_irrigation_confirmed: "Producer confirmed no irrigation was applied",
        irrigation_log_missing: "No applied irrigation record for this window",
      },
      action: {
        validate_water_status_in_field: "Validate the water status in the field",
        review_canonical_water_balance_before_any_irrigation_decision:
          "Review the canonical water balance before any irrigation decision",
        review_applied_irrigation_log: "Review the applied irrigation log",
        rule_out_non_water_causes_of_the_satellite_signal:
          "Rule out non-water causes of the satellite signal (nutrition, pest, disease, management)",
        complete_canonical_root_zone_balance_evidence:
          "Complete the FAO-56 root-zone balance evidence",
        monitor_reference_crop_demand_and_crop_condition:
          "Monitor reference crop demand and crop condition",
        reconcile_conflicting_water_evidence_channels:
          "Reconcile the conflicting water evidence sources",
        continue_routine_monitoring: "Continue routine monitoring",
        complete_missing_water_evidence_via_existing_modules:
          "Complete the missing water evidence in the existing modules",
      },
      evidence: {
        water_stress_evidence: "water evidence",
        single_kc_reference_demand: "FAO-56 reference crop-water demand",
        canonical_root_zone_balance: "FAO-56 root-zone water balance",
        canonical_soil_water_balance: "canonical soil water balance",
        recent_satellite_water_signal: "recent satellite water signal",
        observed_precipitation: "observed precipitation",
        forecast_precipitation: "forecast precipitation",
        irrigation_log: "applied irrigation log",
      },
    },
  },
};
export type AdvisorEn = typeof advisorEn;